{
  "en": {
    "admin": {
      "actions": {
        "add": {
          "company": "Company",
          "instance": "Instance",
          "user": "User"
        },
        "archive": {
          "name": "Archive"
        },
        "delete_item": {
          "name": "Delete",
          "shortcut": "Del"
        },
        "duplicate": {
          "name": "Duplicate",
          "shortcut": "Maj + D"
        },
        "edit_expiration_date": {
          "name": "Edit expiration date",
          "shortcut": "Maj + X"
        },
        "edit_item": {
          "name": "Edit",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "Rename"
        },
        "edit_line_admin": {
          "name": "Edit line",
          "shortcut": "E"
        },
        "edit_manager": {
          "name": "Edit manager",
          "shortcut": "M"
        },
        "edit_managers": "Edit managers",
        "reactiv_license": {
          "name": "Update expiration date license"
        },
        "unarchive": {
          "name": "Unarchive"
        }
      },
      "add": {
        "company": {
          "name": "Add Company",
          "shortcut": "Shortcut"
        },
        "instance": {
          "name": "Add Instance",
          "shortcut": "Shortcut"
        },
        "user": {
          "name": "Add User",
          "shortcut": "Shortcut"
        }
      },
      "communication": {
        "create": {
          "success_message": "Communication was successfully created."
        },
        "destroy": {
          "failure_message": "Communication could not be deleted.",
          "success_message": "Communication %{name} was successfully destroyed."
        },
        "update": {
          "success_message": "Communication was successfully updated."
        }
      },
      "communications": {
        "partials": {
          "toolbar": {
            "refresh": "Communications",
            "refresh_confirm": "Refresh the following tables: %{tables}",
            "refresh_title": "Refresh communications"
          }
        }
      },
      "company": {
        "create": {
          "success_message": "Company was successfully created."
        },
        "destroy": {
          "failure_message": "Company could not be deleted.",
          "success_message": "Company %{name} was successfully destroyed."
        },
        "update": {
          "success_message": "Company was successfully updated."
        }
      },
      "delete_confirm": "Are you sure you want to delete this/these item(s)?",
      "details": {
        "title": "Details"
      },
      "instances": {
        "archive_instance": "Archived instances",
        "create": {
          "success_message": "Instance was successfully created."
        },
        "destroy": {
          "failure_message": "Instance could not be deleted.",
          "success_message": "Instance %{name} was successfully destroyed."
        },
        "root_instance": "Instances",
        "toggle_archive": {
          "success_message": "The instance has been updated."
        },
        "update": {
          "success_message": "Instance was successfully updated."
        }
      },
      "overview": {
        "columns": {
          "communication": {
            "name": "Name of communication"
          }
        }
      },
      "partials": {
        "toolbar": {
          "refresh": "Users",
          "refresh_confirm": "Refresh the following tables: %{tables}",
          "refresh_title": "Refresh users"
        }
      },
      "refresh": {
        "refresh_success": "Database refreshed"
      },
      "refresh_users": {
        "refresh_success": "Database refreshed"
      },
      "toolbar": {
        "search": "Search"
      },
      "user": {
        "create": {
          "success_message": "User was successfully created."
        },
        "default_language": {
          "english": "English",
          "french": "French"
        },
        "destroy": {
          "failure_message": "User could not be deleted.",
          "success_message": "User successfully destroyed."
        },
        "update": {
          "success_message": "User was successfully updated."
        }
      },
      "users": {
        "edit_expiration_date": {
          "title": "Edit expiration dates"
        },
        "edit_manager": {
          "title": "Edit manager(s)"
        },
        "partials": {
          "details_item": {
            "empty_partners": "No team."
          }
        },
        "update_expiration_date": {
          "success": "Update successful."
        },
        "update_manager": {
          "success": "Update successful."
        }
      }
    },
    "analysis": {
      "abs_sum": "Absolute values sum",
      "both": "ℝ %",
      "broken_message": "The case study contains broken items, please fix them, else the results might be off",
      "change": "Change",
      "charts": "Charts",
      "compare": "Comparison",
      "copy": "Copy",
      "decimal": {
        "text": "0.00",
        "title": "Notation Decimal"
      },
      "display": {
        "gross_and_percent_values": "Show gross values ​​and percentages",
        "gross_values": "Show gross values",
        "hidden_items_excluded_from_sum": "Hidden items are excluded from the sum",
        "indicators": "Indicators",
        "normalized_values": "Show normalized values",
        "path": "Display path",
        "percent_values": "Show percentages",
        "show_full_indicator_names": "Show full indicator names",
        "weighted_values": "Show weighted values",
        "zero_values": "Rows at 0"
      },
      "download_as_csv": "Download as CSV",
      "download_as_excel": "Download as Excel",
      "error_displaying_results_message": "There was an error displaing the results, try recomputing",
      "expand_table": "Expand/reduce table",
      "export": {
        "current_table": "Export current table"
      },
      "go_to_container": "Go to selected container",
      "gross": "ℝ",
      "hidden": "hidden",
      "indicator_flow_component": {
        "flow": "Flows",
        "flow_hidden": "Flows (%{hidden} hidden)",
        "negative_sum": "Sum (negative values)",
        "others": "Others",
        "others_negative_subtotal": "Others (negative values)",
        "others_positive_subtotal": "Others (positive values)",
        "positive_sum": "Sum (positive values)",
        "sum": "Sum",
        "unit": "Unit",
        "weighting_factor": "Factor"
      },
      "indicator_tree_component": {
        "edit_normalization": "(edit)",
        "hide_row": "Exclude row from sum results",
        "normalization": "Normalization:",
        "normalization_none": "No Normalization",
        "ponderation": "Weighting:",
        "ponderation_none": "No Weighting",
        "show_row": "Include row in sum results",
        "submit_normalization": "Apply",
        "track": "Track indicator in design"
      },
      "indicators": "Indicators",
      "indicators_impacts_by_dataset_component": {
        "column_80percent": "80%",
        "ecobilan": "Ecobilan",
        "indicators": "Indicators",
        "module": "Dataset",
        "no_threshold": "No Threshold",
        "other": "Others (%{num_items} datasets)",
        "other_dataset": "Other: %{name}",
        "other_negative": "including negative values",
        "other_positive": "including positive values",
        "phase_name": "Phase",
        "phases": "Phases",
        "sum": "Sum of absolute values",
        "threshold": "Threshold",
        "with_energetic_mix": "+"
      },
      "indicators_set_informations": "Informations",
      "indicators_set_results_tabs_component": {
        "impacts_by_dataset": "Contributions - Datasets",
        "normalization_and_weightings": "Normalization & weighting",
        "results_by_item": "Contributions - Life cycle"
      },
      "indicators_sets": {
        "spreadsheet": {
          "normalized": "Normalized",
          "weighted": "Weighted"
        }
      },
      "informations": "<p>To start a computation:</p>\n  <p class='ms-5'>1. Click on the icon <i class=\"fa-regular fa-circle-play\"></i></p>\n  <p class='ms-5'>2. Wait for the icon to turn green <i class=\"fa-solid fa-circle text-success\"></i></p>\n  <p class='ms-5'>3. Click on the name to display the results.</p>\n  <p class='mt-4'>If the icon is yellow <i class=\"fa-solid fa-circle text-warning\"></i> your results are out of date. Click on the icon <i class=\"fa-regular fa-circle-play\"></i> to recalculate.</p>\n",
      "name": "Name",
      "negative_others": "Other negatives",
      "negative_others_contains": "Other negatives",
      "negative_subtotal": "Negative subtotal",
      "no_parameters_set": "No parameters set.",
      "normalized_indicators_table_component": {
        "characterisation": "Characterization",
        "edit_normalization": "(edit)",
        "indicator": "Indicator",
        "norm_factor": "Factor",
        "norm_percent": "Ratio",
        "norm_value": "Result",
        "normalization": "Normalization",
        "normalization_none": "No Normalization",
        "normalized_percentage_major": "Normalized Ratio (%) - more than 80%",
        "normalized_percentage_minor": "Normalized Ratio (%) - less than 20%",
        "show_phases": "Show Phases",
        "submit_normalization": "Submit",
        "sum": "Sum",
        "sum_all_phases": "Sum",
        "sum_with_module_d": "Sum (with module D)",
        "sum_with_phases": "Sum (%{num_enabled_phases}/%{num_phases} phases)",
        "sum_without_module_d": "Sum (without module D)",
        "unit": "Unit",
        "weighted_percentage_major": "Weighted Ratio (%) - more than 80%",
        "weighted_percentage_minor": "Weighted Ratio (%) - less than 20%",
        "weighted_value": "Result",
        "weighting": "Weighting",
        "weighting_factor": "Factor",
        "weighting_none": "No Weighting",
        "weighting_percent": "Ratio"
      },
      "options": "Options",
      "others": "Others",
      "out_of_date_results_message": "This analysis result is outdated, please recompute",
      "overview": {
        "columns": {
          "flow": "Flow",
          "indicator": "Indicator",
          "name": "Name",
          "negative_sum": "Negative sum",
          "path": "Path",
          "positive_sum": "Positive sum",
          "sum": "Sum",
          "unit": "Unit",
          "unit_name": "Weighting factor unit",
          "weighting_factor": "Weighting factor name"
        },
        "titles": {
          "indicator": "Indicator",
          "unit_name": "Unit",
          "weighting_factor": "Factor"
        }
      },
      "parameters_set_enabled": "Active Parameters Set: %{set}",
      "percentage": "%",
      "positive_others": "Other Positives",
      "positive_others_contains": "Other Positives",
      "positive_subtotal": "Positive subtotal",
      "ratio": "Ratio: %{ratio}",
      "result_set_computation_date_component": {
        "item_not_computed": "%{item}: not computed",
        "item_outdated": "%{item}: outdated, was computed on %{date}",
        "item_up_to_date": "%{item}: up to date",
        "not_computed": "The computation is missing some items",
        "outdated": "The computation is outdated. It dates from %{date}.",
        "up_to_date": "The computation is up-to-date (%{date})"
      },
      "scientific": {
        "text": "10<sup>n</sup>",
        "title": "Notation Scientifique"
      },
      "settings": "Settings",
      "show_broken": "See Broken Items",
      "step": "Step",
      "sum": "Sum",
      "threshold": {
        "phase": "Phase",
        "text": "Threshold",
        "title": "Apply a threshold in percentage in order to group together the values ​​lower than this one."
      },
      "total": "Total",
      "total_others": "Others",
      "total_others_contains": "Others",
      "tree": {
        "abbreviation": "Abbreviation",
        "calculate": "Calculate",
        "method": "Method",
        "name": "Complete name",
        "normalization_and_weightings": "Normalization and Weightings",
        "select": "Select to calculate",
        "select_all": "Select all",
        "source": "Source",
        "unit_name": "Unit Name",
        "year": "Year"
      },
      "values": "Values"
    },
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "design": {
      "actions": {
        "back_to_parent": "Go back to parent",
        "collapse": "Collapse an element <kbd>←</kbd>",
        "compare_item": {
          "name": "Compare"
        },
        "copy": "复制 <kbd>shift + C</kbd>",
        "copy_item": {
          "name": "Copy",
          "shortcut": "Maj + C"
        },
        "cut": "剪切 <kbd>shift + X</kbd>",
        "cut_item": {
          "name": "Cut",
          "shortcut": "Maj + X"
        },
        "delete": "删除 <kbd>Del</kbd>",
        "delete_item": {
          "name": "Delete",
          "shortcut": "Del"
        },
        "edit": "编辑 <kbd>shift + E</kbd>",
        "edit_item": {
          "name": "Edit",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "Edit line",
          "shortcut": "E"
        },
        "enter": "Enter an element <kbd>&crarr;</kbd>",
        "expand": "Expand an element <kbd>→</kbd>",
        "fix_broken": {
          "name": "Fix Broken"
        },
        "in_library": "In library",
        "left_region": "Move from one region to the left <kbd>shift + Alt + ←</kbd>",
        "navigate_down": "Move selection down <kbd>↓</kbd>",
        "navigate_up": "Move selection up <kbd>↑</kbd>",
        "navigation": "Navigation with selection",
        "next_tab": "Move to the right tab <kbd>shift + Alt + ↑</kbd>",
        "paste": "粘贴 <kbd>shift + P</kbd>",
        "paste_item": {
          "name": "Paste",
          "shortcut": "Maj + P"
        },
        "previous_tab": "Move to the left tab <kbd>shift + Alt + ↓</kbd>",
        "region": "Navigation by region",
        "reload": "Reload",
        "replace": "Substitute",
        "right_region": "Move from one region to the right <kbd>shift + Alt + →</kbd>",
        "switch_down": "Move from one region down <kbd>shift + Alt + ↓</kbd>",
        "switch_up": "Move from one region up <kbd>shift + Alt + ↑</kbd>"
      },
      "add": {
        "dossier": {
          "name": "Add a folder",
          "shortcut": "1"
        },
        "energy_consumption": {
          "name": "Add an energy consumption",
          "shortcut": 5
        },
        "folder": {
          "name": "Add a folder",
          "shortcut": 1
        },
        "part": {
          "name": "Add a part",
          "shortcut": 3
        },
        "phase": {
          "name": "Add a phase",
          "shortcut": 0
        },
        "subassembly": {
          "name": "Add a subassembly",
          "shortcut": 2
        },
        "transport_step": {
          "name": "Add a freight transport step",
          "shortcut": 4
        }
      },
      "add_elements": "add an element",
      "cs_flows": {
        "create": {
          "notice": "The flow has been added successfully."
        },
        "destroy": {
          "notice": " The flow was successfully deleted."
        },
        "update": {
          "notice": "The flow has been modified successfully."
        }
      },
      "cs_items": {
        "reject_if_cs_item_not_exist": {
          "reject": "Reject"
        }
      },
      "cs_modules": {
        "create": {
          "notice": "The module has been added successfully."
        },
        "destroy": {
          "notice": "The module has been successfully deleted."
        },
        "update": {
          "notice": "The module has been successfully modified."
        }
      },
      "cs_phases": {
        "create": {
          "notice": "The phase has been added successfully."
        },
        "destroy": {
          "notice": "The phase was successfully deleted."
        },
        "update": {
          "notice": "The phase was successfully modified."
        }
      },
      "delete_confirm": "Are you sure to delete this/these item (s)?",
      "display": {
        "visible_columns": "Visible columns"
      },
      "elements_actions": "Actions on an element",
      "items_filter_component": {
        "broken_modules": "Broken modules",
        "families": "Families",
        "item_types": "Element types",
        "module_types": "Module types",
        "obsolescence": "Obsolescence",
        "phases": "Phases",
        "reset": "Reset",
        "search": "Search",
        "update": "Update"
      },
      "library": {
        "add": "Add",
        "clear": "Clear",
        "deprecated_since": "Obsolete since %{date}",
        "deprecated_soon": "Dataset obsolete soon",
        "favorites": "Favorites",
        "filter": {
          "family": "Family"
        },
        "flat_version_template": "%{name} (v%{version})",
        "flows": "Flows",
        "included_versions": "(different versions included)",
        "info": "Information",
        "latest_module_version_template": "Version %{version} (latest): %{date}",
        "module": "Module",
        "module_version_template": "Version %{version}: %{date}",
        "modules": "Modules",
        "no_results": "No Results",
        "search": "Search",
        "search_favorites": "Search favorites",
        "search_favorites_title": "Search favorites, conditional operator as AND, OR, NOT are available and \"\" and () as well",
        "search_flows": "Search flows",
        "search_flows_title": "Search flows, conditional operator as AND, OR, NOT are available and \"\" and () as well",
        "search_modules": "Search datasets",
        "search_modules_title": "Search datasets, conditional operator as AND, OR, NOT are available and \"\" and () as well",
        "search_systems": "Search systems",
        "search_systems_title": "Search systems, conditional operator as AND, OR, NOT are available and \"\" and () as well",
        "shared_by": "%{item_name} - shared by %{user_name}",
        "systems": "Systems"
      },
      "name": "Name",
      "overview": {
        "columns": {
          "badges": {
            "reusable": "<p><strong>Reusable</strong></p>\n<p>A good or component is reusable if, at the end of the product's life, it can be reused for the same or another function without transforming the material it contains.</p>\n",
            "use_as_process": "<p><strong>Used as process</strong></p>\n<p>Refers to a material or component consumed during the manufacturing process of a good, and which is not included in the material composition of this good.</p>\n"
          },
          "category_with_inheritance": "Category",
          "comments": "Comments",
          "computed_quantity": "Cumul. Quantity",
          "created_at": "Creation date",
          "ecobilan_identifier": "Eco. Id",
          "ico": "Ico",
          "id": "EIME Identifiant",
          "loss_rate_percentage": "Loss rate percentage",
          "lr": "LR",
          "name": "Name",
          "net_calorific_value": "LHV",
          "path": "Path",
          "quantity": "Quantity",
          "quantity_formula": "Quantity Formula",
          "rank": "#",
          "renewable_p": "RP",
          "second_quantity": "Sec. Qua.",
          "state": "State",
          "titles": {
            "category_with_inheritance": "Category (with inheritance)",
            "comments": "Commentaire [Com.]",
            "computed_quantity": "Cumulative quantity",
            "created_at": "Created at",
            "ecobilan_identifier": "Ecobilan Identifiant [Eco. Id]",
            "ico": "Icon [Ico]",
            "id": "Id",
            "loss_rate_percentage": "Loss rate percentage",
            "lr": "Loss Rate (%) [LR]",
            "name": "Name",
            "net_calorific_value": "Lower heating value [LHV]",
            "path": "Path",
            "quantity": "Quantity",
            "rank": "Rank [#]",
            "renewable_p": "Renewable percentage (%) [RP]",
            "second_quantity": "Second Quantity [Sec. Qua.]",
            "state": "State",
            "tracking_gross": "Tracking gross",
            "tracking_percent": "Tracking percent",
            "updated_at": "Updated at",
            "use_as_process": "Used as process [UAP]"
          },
          "tracking": "Tracking",
          "tracking_gross": "Tracking",
          "tracking_percent": "Tracking (%)",
          "updated_at": "Updated at",
          "use_as_process": "UAP"
        }
      },
      "partials": {
        "tracking_button": {
          "flows": "Flows",
          "none": "Delete current tracking",
          "relative_to_case_study": "Percentage relative to case study",
          "relative_to_phase": "Percentage relative to phase",
          "relative_to_view": "Percentage relative to current view"
        }
      },
      "replace": {
        "all": "Substitute in entire case study",
        "btn": "Substitute",
        "db_flow_uuid": "ext_id of flow dataset, for ex: f54a4bc1-68ef-4332-a1a2-760ad5b72168",
        "errors": {
          "db_item_not_found": "No element was found with this id : %{id}",
          "db_item_not_provided": "Please provide a new dataset.",
          "replace_fail": "The substitution failed, please try again or contact EIME support."
        },
        "new": "New",
        "previous": "Previous",
        "replace_all_is_unavailable": "Global substitution (replace all the same elements in the case study) is not available for this dataset.",
        "title": "Substitute an element"
      },
      "search": {
        "search_elements": "Search in case study"
      },
      "search_case_study": "Search in the case study",
      "searches": {
        "case_study": "Search in case study <kbd>Maj + f </kbd>",
        "library": "Search in active library <kbd>f<kbd>",
        "project": "Search in project <kbd>shift + Alt + f<kbd>",
        "title": "Search"
      },
      "shortcuts": "Shortcuts",
      "show_shortcuts": "Show shortcuts<kbd>shift + ?</kbd>",
      "tracking_off": "Trackings",
      "tracking_on": "Targeting on %{indicator_name}",
      "tree": {
        "containers": "Containers",
        "expand_all": "Expand all"
      }
    },
    "front": {
      "actions": {
        "confirm": {
          "archive_database_upgrade_chronicle": "Do you confirm you want to archive this upgrade ? All upgrades that ran before this one will also be archived, if they are not already.",
          "delete_database_upgrade_step": {
            "one": "⚠️ One dataset is currently associated with this step. If you delete this step, this data will be removed from the automatic upgrade process. Do you confirm the deletion?",
            "other": "⚠️ %{count} datasets are currently associated with this step. If you delete it, these datasets will be removed from the automatic update process. Are you sure you want to delete it?",
            "zero": "Are you sure you want to delete it? The risk of this operation is low because no dataset is associated with this step."
          },
          "delete_item": "Are you sure you want to delete this/these item(s)?",
          "launch_database_upgrade_step": "Selected step: %{name}. Do you confirm the launch of this upgrade ?",
          "make_available": "Do you confirm the availability of this item ? It will be available from today. This action is irreversible.",
          "prune_items": "Are you sure you want to delete all items with a quantity defined to zero ?"
        },
        "errors": {
          "contact_support": "Something went wrong, please contact EIME support.",
          "unauthorized": "You are not allowed to perform this action."
        },
        "name": {
          "add_case_study": "Add case study",
          "add_category": "Add a category",
          "add_company": "Add a company",
          "add_database_upgrade_step": "Add a step",
          "add_db_module_substitution": "Define a substitution",
          "add_dossier": "Add folder",
          "add_energy_consumption": "Add energy consumption",
          "add_flow": "Add a flow",
          "add_indicator": "Add an indicator",
          "add_indicators_set": "Add an indicator set",
          "add_instance": "Add an instance",
          "add_item": "Add item",
          "add_linked_module": "Add as linked dataset",
          "add_linked_module_types": {
            "end_of_life": "End of life",
            "linked_process": "Process",
            "module_d": "Module D"
          },
          "add_module": "Create a module",
          "add_module_version": "New version",
          "add_part": "Add part",
          "add_phase": "Add phase",
          "add_project": "Add project",
          "add_subassembly": "Add subassembly",
          "add_tag": "Add a tag",
          "add_transport_step": "Add transport step",
          "add_user": "Add a user",
          "archive_item": "Archive",
          "bookmark": "Bookmark",
          "cancel_database_upgrade_chronicle": "Cancel this upgrade",
          "check": "Check the dataset",
          "compare_db_modules": "Compare",
          "copy_item": "Copy",
          "copy_ref_id": "Copy ref id",
          "cut_item": "Cut",
          "define_global_template": "Define as global template",
          "delete_item": "Delete",
          "deprecate": "Obsolete",
          "download_case_study_source": "Download case study source",
          "duplicate": "Duplicate",
          "duplicate_item": "Duplicate item",
          "edit_contributors": "Edit contributors",
          "edit_expiration_date": "Edit expiration date",
          "edit_icv": "Edit LCI",
          "edit_item": "Edit",
          "edit_line": "Edit line",
          "edit_manager": "Edit manager",
          "edit_normalization": "Edit Normalization",
          "edit_parameters": "Parameters",
          "edit_ponderation": "Edit Weighting",
          "edit_rank": "Edit rank",
          "edit_scenarios": "Edit scenarios",
          "edit_tokens": "Edit Tokens",
          "edit_workflow_and_publication_status": "Status",
          "export": {
            "analysis": "Analysis (advanced)",
            "analysis_json": "Analysis (advanced, JSON)",
            "comparison": "Comparison",
            "design": "Design",
            "eime": "Eime",
            "inies": "Inies",
            "json_case_study": "Design JSON",
            "multi_tracking": "Design (with all trackings)",
            "name": "Export",
            "pep_ecopassport": "PEP Ecopassport",
            "simplified_analysis": "Analysis",
            "simplified_analysis_json": "Analysis (JSON)",
            "tracking": "Design (with current tracking)"
          },
          "export_database_upgrade_chronicle": "Export the change report",
          "export_module": "Export",
          "find_in_library": "Find in library",
          "fix_broken": "Fix broken items",
          "forward": "Forward",
          "go_to_comparison": "Go to comparison",
          "import_case_study": "Import case study",
          "import_case_study_here": "Import case study in this folder",
          "import_module": "Import Modules",
          "info_item": "Informations",
          "launch_database_upgrade_step": "Launch this upgrade",
          "make_available": "Make available",
          "mark_as_favorite": "Mark as favorite",
          "paste_item": "Paste",
          "paste_item_here": "Paste in this element",
          "permissions": "Permissions",
          "prune_items": "Clean up the model",
          "recompute_broken": "Recompute broken items",
          "refresh_children": "Refresh database for child instances",
          "refresh_module_impacts": "Compute impacts",
          "reinitialize": "Reinitialize state",
          "remove_analysis_results": "Remove analysis results",
          "remove_from_favorite": "Remove from favorites",
          "remove_global_template": "Remove from global templates",
          "replace_cs_modules": "Datasets",
          "replace_cs_transport_steps": "Transport steps",
          "replace_item": "Substitute",
          "reset_item_path": "Recompute item_path",
          "share": "Share",
          "status": "Status",
          "transform_to_module": "Transform to Dataset",
          "transform_to_template": "Transform to template",
          "unarchive_item": "Unarchive",
          "unmark_as_template": "Unmark as template",
          "unshare": "Unshare",
          "update_items": "Update datasets"
        },
        "restriction": {
          "paid_licence": "Paid licence"
        },
        "title": {
          "add_case_study": "Add case study",
          "add_category": "Add a category",
          "add_dossier": "Add folder",
          "add_energy_consumption": "Add energy consumption",
          "add_item": "Add item",
          "add_part": "Add part",
          "add_phase": "Add phase",
          "add_project": "Add project",
          "add_subassembly": "Add subassembly",
          "add_transport_step": "Add transport step",
          "archive_item": "Archive",
          "bookmark": "Bookmark",
          "compare_db_modules": "Compare",
          "copy_item": "Copy",
          "copy_ref_id": "Copy ref id",
          "cut_item": "Cut",
          "define_global_template": "Define as global template",
          "delete_item": "Delete",
          "download_case_study_source": "Download case study source",
          "duplicate": "Duplicate",
          "duplicate_item": "Duplicate item",
          "edit_contributors": "Edit contributors",
          "edit_expiration_date": "Edit expiration date",
          "edit_icv": "Edit LCI",
          "edit_item": "Edit",
          "edit_line": "Edit line",
          "edit_manager": "Edit manager",
          "edit_normalization": "Edit Normalization",
          "edit_parameters": "Parameters",
          "edit_ponderation": "Edit Weighting",
          "edit_scenarios": "Edit scenarios",
          "edit_tokens": "Edit Tokens",
          "edit_workflow_and_publication_status": "Status",
          "export": {
            "analysis": "Analysis (advanced)",
            "analysis_json": "Analysis (advanced JSON)",
            "comparison": "Comparison",
            "design": "Design",
            "eime": "Eime",
            "inies": "Inies",
            "json_case_study": "Design JSON",
            "multi_tracking": "Design (with all trackings)",
            "name": "Export",
            "pep_ecopassport": "PEP Ecopassport",
            "simplified_analysis": "Analysis",
            "simplified_analysis_json": "Analysis (JSON)",
            "tracking": "Design (with current tracking)"
          },
          "export_module": "Export",
          "find_in_library": "Find in library",
          "fix_broken": "Fix broken items",
          "forward": "Forward",
          "go_to_comparison": "Go to comparison",
          "import_case_study": "Import case study",
          "import_case_study_here": "Import case study in this folder",
          "info_item": "Informations",
          "make_available": "Make available",
          "mark_as_favorite": "Mark as favorite",
          "paste_item": "Paste",
          "paste_item_here": "Paste in this element",
          "permissions": "Permissions",
          "prune_items": "Trash items with empty quantity",
          "recompute_broken": "Recompute broken items",
          "refresh_module_impacts": "Compute impacts",
          "reinitialize": "Reinitialize state",
          "remove_analysis_results": "Remove analysis results",
          "remove_from_favorite": "Remove from favorites",
          "remove_global_template": "Remove from global templates",
          "replace_cs_modules": "Substitute datasets",
          "replace_cs_transport_steps": "Substitute transport steps",
          "replace_item": "Substitute",
          "reset_item_path": "Recompute item_path",
          "share": "Share",
          "status": "Status",
          "transform_to_module": "Transform to Dataset",
          "transform_to_template": "Transform to template",
          "unarchive_item": "Unarchive",
          "unmark_as_template": "Unmark as template",
          "unshare": "Unshare",
          "update_items": "Update datasets"
        }
      },
      "check_session_timeout": {
        "disconnect": "Disconnect",
        "reconnect": "Reconnect",
        "stay_connected": "Stay Connected",
        "stay_connected_timer": "Stay Connected (%{seconds_left})",
        "too_late_message": "Your session has been disconnected because it was left idle too long.",
        "warning_timeout": "Your session is about to expire. Without any action on your part, you will soon be disconnected."
      },
      "controllers": {
        "analysis_flow_table": {
          "track_flow": "Track flow in design"
        },
        "current_view": {
          "view_changed": "This page has changed, click to refresh it."
        },
        "date_validator": {
          "not_a_valid_date": "must be a valid date"
        },
        "debug/running_queries": {
          "confirm_kill": "Kill process %{pid} ? This could make the whole database restart.",
          "confirm_terminate": "Stop request %{pid}?",
          "kill": "Kill postgresql process",
          "terminate": "Terminate request"
        },
        "infinite_scroll": {
          "more_items": "Loading more items..."
        },
        "make_cs_module": {
          "discard_unsaved": "Discard unsaved changes?"
        },
        "parameters": {
          "destroy_parameter": "Are you sure you want to destroy this parameter ?",
          "destroy_parameters_set": "Are you sure you want to destroy this parameters set ?",
          "download": "Find your file in the downloads.",
          "error": "Error",
          "saved": "Saved",
          "saving": "Saving..."
        },
        "step_form": {
          "discard_unsaved": "Discard unsaved changes?",
          "errors_occured": "Please check form, some errors occurred while saving."
        }
      },
      "database": {
        "publish": {
          "success": "Your item has been published."
        }
      },
      "interface": {
        "admin": "admin",
        "analysis": "analysis",
        "comparison": "comparison",
        "database": "database",
        "design": "design",
        "home": "home",
        "project": "project"
      },
      "long_poll": {
        "disconnected": "Click to refresh the page."
      },
      "ping": {
        "check_websockets": "Check Websockets",
        "warning_missing_websockets": "<p>In order to improve the performance of EIME, we will shortly be implementing WebSocket.</p>\n<p>If the WebSocket protocol is blocked by your company, please contact our IT department or your IT department.</p>\n"
      }
    },
    "helpers": {
      "true_admin_only": {
        "admin": "admin",
        "visible_only_to_admins": "Visible only to administrators"
      }
    },
    "make": {
      "actions": {
        "close": "Close",
        "extract": "Extract in a new window",
        "minimize": "Minimize"
      },
      "choose_parent": {
        "add_phase": "Add a phase",
        "choose_parent": "Please choose a life cycle phase for your item.",
        "create_phase": "Please create life cycle phases before adding other items.",
        "submit": "Continue"
      },
      "create": {
        "notice": "Notice"
      },
      "cs_case_studies": {
        "clear_template": {
          "notice": "The case study is not a template anymore."
        },
        "create": {
          "notice": "Notice"
        },
        "export": {
          "notice": "Export in progress..."
        },
        "form": {
          "database": "Databases",
          "database_selector": "All databases",
          "general_information": "Parameters",
          "incoming": "Incoming",
          "incoming_tooltip": "The percentage of losses are expressed according to the quantity of losses generated in relation to the incoming material, the following formula is used:<br>Loss rate = Quantity of losses / Incoming quantity.<br>This methodology is the one commonly used in the industry and is used by default in EIME.",
          "informations": "Information",
          "no_energetic_mix_marked_as_favorite": "No energy mix marked as favorite",
          "outgoing": "Outgoing",
          "outgoing_tooltip": "The percentage of losses are expressed according to the quantity of losses generated in relation to the outgoing material, the following formula is used:<br>Loss rate = Quantity of losses / Outgoing quantity.<br>This methodology is the one used by default in the assumptions of the PEP Ecopassport program.",
          "pep_compliant_loss_rate_change_label": "Loss Percentage expressed in relation to the material",
          "pep_compliant_loss_rate_change_message": "Please note that you have changed the method for calculating loss quantities. This change will affect your results.",
          "popover_content": "By default, losses are calculated in relation to the incoming material, i.e. Loss rate = Quantity of losses / Incoming quantity.<br>It is possible to change the calculation of losses so that they are calculated in relation to the outgoing material, i.e. Loss rate = Quantity of losses / Outgoing quantity",
          "popover_title": "Loss Rate calculations",
          "template_comments": "Template comments"
        },
        "import": {
          "cs_counter_limit_exceeded": "Your current licence does not allow you to create more case studies. You have %{file_limit} case studies left, and you are trying to import %{files_imported}.",
          "file_import_limit_exceeded": "You have selected more than %{file_limit} case studies.<br>\nTo ensure optimal performance, please limit your selection.\n",
          "notice": "Your import is in progress."
        },
        "indicators_set": {
          "error": "Error",
          "notice": "Notice"
        },
        "mark_template": {
          "notice": "The case study has been marked as template."
        },
        "new": {
          "cs_counter_limit_exceeded": "Your current licence does not allow you to create more case studies."
        },
        "update": {
          "notice": "The case study is modified with success."
        },
        "upload_button": "Upload"
      },
      "cs_containers": {
        "create": {
          "notice": "The container has been added successfully.",
          "system": "The system is being created."
        },
        "destroy": {
          "notice": " The container has been successfully deleted."
        },
        "form": {
          "category_with_inheritance": "Inherited category : %{inherited_category}",
          "container_type": "Container type",
          "general_information": "Parameters",
          "no_category": "none",
          "title": {
            "dossier": "Container",
            "part": "Part",
            "phase": "System phase",
            "subassembly": "Subassembly"
          }
        },
        "update": {
          "notice": "The container has been successfully modified."
        }
      },
      "cs_energy_consumptions": {
        "form": {
          "general_information": "Parameters",
          "title": {
            "energy_consumption": "Energy Consumption"
          }
        }
      },
      "cs_flows": {
        "form": {
          "general_information": "Parameters",
          "title": {
            "category": "Category",
            "flow": "Flow"
          }
        },
        "multi_replace": {
          "success": {
            "one": "%{count} flow has been successfully substituted.",
            "other": "%{count} flows have been successfully substituted."
          }
        },
        "new_multi_replace": {
          "disclaimer_units": "If the unit group (mass, metric...) required by the new dataset differs from the old one, the new one will be assigned a new default unit.",
          "disclaimer_values": "Values from old modules or flows are systematically transferred to the new ones.",
          "title": "Substitute"
        }
      },
      "cs_folders": {
        "form": {
          "general_information": "Parameters",
          "title": {
            "folder": "Folder"
          }
        }
      },
      "cs_items": {
        "admin_recompute_broken": {
          "notice": "Recomputing broken modules in progress..."
        },
        "bookmark": {
          "add": " The item is now part of your favorites. You can find it in the \"Systems\" tab.",
          "remove": "The item is no longer part of your favorites."
        },
        "create": {
          "success": "Item was successfully created."
        },
        "forward_chown": {
          "error": "Cannot forward.",
          "success": {
            "one": "Item is being forwarded.",
            "other": "items are being forwarded."
          }
        },
        "forward_copy": {
          "error": "Cannot forward and copy.",
          "success": {
            "one": "Item is being forwarded.",
            "other": "items are being forwarded."
          }
        },
        "move": {
          "error": {
            "phase_moves_only_in_case_study": "A phase should be at the root of a case study only."
          }
        },
        "multi_destroy": {
          "success": {
            "one": "Item is deleting.",
            "other": "Items are deleting."
          }
        },
        "multi_destroy_message": {
          "default": "Would you like to put to trash %{num_items} items?",
          "error_unlink_energetic_mix": "You cannot put to trash an energy mix module without its parent",
          "with_linked": "Would you like to put to trash %{num_items} item(s) (including %{num_linked} linked module(s))?"
        },
        "multi_fix_broken": {
          "notice": "Repairing modules in progress..."
        },
        "multi_update": {
          "success": "Items are successfully updated."
        },
        "multi_update_version": {
          "notice": "Updating modules in progress..."
        },
        "paste": {
          "error": {
            "cannot_paste_inside_itself": "An item cannot be pasted inside itself.",
            "cannot_paste_trashed": "One or more items in your clipboard are trashed. Restore these items if you want to paste them.",
            "case_study_restrictions": "A case study cannot be placed inside another case study.",
            "containers_restrictions": "A container (folder, subassembly, part) has to be placed inside a phase or another container.",
            "folder_restrictions": "A project folder cannot be placed inside a case study.",
            "leafs_restrictions": "Flow, Modules, Transport Steps and Energy Consumption have to be placed inside a phase or a container.",
            "module_d_restrictions": "Only one phase of type module D is allowed in a case study.",
            "no_items": "No items to paste.",
            "one": "Item cannot be pasted.",
            "other": "Items cannot be pasted.",
            "phase_restrictions_duplicate": "A phase has to be pasted inside a case study root, another phase or a container.",
            "phase_restrictions_move": "A phase can only be moved inside a case study root."
          }
        },
        "reinitialize": {
          "success": {
            "one": "Item was successfully reinitialized.",
            "other": "Items were succesfully reinitialized."
          }
        },
        "reject": "You cannot do any actions or go to an item which is not valid.",
        "reject_insert": "You cannot insert this element at the root of a case study.",
        "share": {
          "add": "The item is shared. You can find it in the tab \"Systems\".",
          "remove": "The item is no longer shared."
        },
        "track": {
          "notice": "Tracking was succesfully updated."
        },
        "update": {
          "success": "Item was succesfully updated."
        }
      },
      "cs_module_form": {
        "common_fields_component": {
          "popover_secondary_quantity_formula": "Impact of the dataset = LCI * 1st quantity value * (2nd quantity value / 2nd quantity reference value)"
        },
        "preload_scenario_component": {
          "creation": "Modules Creation",
          "energetic_mix_shortcut": "Shortcut - automatic completion of energy mixes"
        }
      },
      "cs_modules": {
        "form": {
          "add": "Add",
          "add_module": "+&nbsp;&nbsp;Module",
          "add_scenario": "+&nbsp;&nbsp;Scenario",
          "advanced_parameters": "Advanced parameters",
          "broken": "Broken dataset",
          "creating": "In the making",
          "db_module_not_found": "Dataset not found.",
          "deprecated_soon": "Dataset obsolete soon",
          "deprecated_soon_popover": "This data will be made obsolete for projects with a date prior to %{date}. A more suitable dataset should be available in the database.",
          "documentation": "See full documentation",
          "end_of_life": "End of Life",
          "energetic_mix": "Energy mix",
          "favorite_mixes": "Favorites",
          "forbidden_scenario": "This scenario is incompatible with your project date or license.",
          "general_information": "General information",
          "info_ecobilan_id": "Ecobilan id.",
          "info_module_uuid": "Module UUID",
          "info_version": "Version (availability date)",
          "information": "Information",
          "linked_process": "Process",
          "loss_rate_percentage_variable": "Lr",
          "loss_rate_variable_math": "<msub><mi>L</mi><mi>r</mi></msub>",
          "main_module": "Main Module",
          "module_d": "Module D",
          "non_favorite_mixes": "Others",
          "quantity_including_losses": "Quantity including losses",
          "quantity_losses": "Quantity of losses : ",
          "quantity_variable": "Q",
          "quantity_variable_math": "<mi>Q</mi>",
          "renewable_percentage_hint": " The renewable percentage means the product weight percentage from renewable sources, such as sustainable forestry.",
          "second_parameters_html": "This module has been modelled to be representative between <b>%{min}</b> and <b>%{max}</b> <b>%{unit}</b>.",
          "second_parameters_name_html": "This module has been modelled with the following criterion <b>%{name}</b> as the second parameter.",
          "second_quantity_variable": "Q2",
          "select_a_scenario": "Select a scenario",
          "submit": "Save and Close",
          "update": "Save",
          "warning_partly_terminated": "Please note that this dataset is only partial.\nPlease refer to the documentation and follow the instructions in the 'Use advice for data set' section to complete this data.\nIf this data offers process scenarios, you must add them to complete the data.\n"
        },
        "show": {
          "read_only_flag": "Read-only"
        },
        "update": {
          "notice": "The module has been updated"
        }
      },
      "cs_phases": {
        "form": {
          "general_information": "Parameters",
          "title": {
            "phase": "Phase"
          }
        }
      },
      "cs_projects": {
        "create": {
          "success": "Project was successfully created."
        },
        "form": {
          "general_information": "Parameters",
          "title": {
            "project": "Project"
          }
        },
        "update": {
          "success": "Project was successfully updated."
        }
      },
      "cs_systems": {
        "create": {
          "system": "System"
        },
        "form": {
          "create": "Add a system",
          "title": {
            "system": "System"
          }
        },
        "new": {
          "advanced_insertion": "Advanced insertion",
          "advanced_insertion_description": "Choose where and what part of the system you want to insert within your case study.",
          "create": "Add a system",
          "expected_lifetime": "Lifetime",
          "functional_unit_ratio": "Functional unit ratio",
          "general_information": "Parameters",
          "in": "in",
          "information": "Information",
          "insert_in_phase": "in the phase %{phase_name}",
          "insert_phase": "Insert phase(s)",
          "insert_phases_methods": "Phase insertion methods",
          "not_allowed": "A system cannot be inserted at the root of a case study.",
          "quick_insertion": "Quick insertion",
          "quick_insertion_description": "Insert the whole system within your current location",
          "real_weight": "Real weight",
          "title": "Add a system",
          "warning": "The ratio of the functional unit is indicative and will not be taken into account for the current case study."
        }
      },
      "cs_transport_steps": {
        "edit": {
          "title": "Edit « %{name} »"
        },
        "form": {
          "average_load_percentage_information": "The transport steps formula has been developed for an average load over 50%.",
          "general_information": "Parameters",
          "header": "Freight Transport Step"
        },
        "new": {
          "title": "Add transport step"
        }
      },
      "db_flows": {
        "form": {
          "general_information": "Parameters"
        },
        "publish": {
          "success": "The flow has been published."
        }
      },
      "db_module_from_cs_case_studies": {
        "new": {
          "back": "Back",
          "force_type_of_dataset": "Force the type of dataset (leave empty for default)"
        },
        "new_preset": {
          "recommendation": "You are about to begin the process of making a dataset from a case study.\nPlease check that your case study is up to date with the latest datasets versions and that it does not contain any broken elements.\n"
        }
      },
      "db_module_scenarios": {
        "breadcrumb": {
          "title": "Scenarios for [%{ecobilan}]"
        },
        "copy_scenarios": {
          "all_linked_modules_types": "All",
          "any_version": "Available for all versions of the dataset %{ecobilan}",
          "provider": "Dataset providing the scenarios",
          "quantity_formula": "New quantity formula",
          "second_quantity_formula": "New second quantity formula (if necessary)",
          "select_scenarios_type": "Select scenarios",
          "submit": "Start copying",
          "subtitle": "Copy scenarios",
          "title": "Scenarios for %{name}",
          "update_quantity_formula": "Update quantity formula"
        },
        "edit": {
          "title": "Scenarios for %{name}"
        },
        "form": {
          "new_module": "Add module"
        },
        "form_for_scenario_linked_module_component": {
          "could_not_find_module_in_database": "The module could not be found in database.",
          "destroy_confirm": "Do you confirm the deletion of this module ?",
          "popover_content": "You must write here a formula containing at least one of the following variables : <br><br> <strong>· containers_quantity<br>· quantity_with_losses<br>· quantity_without_losses<br>· quantity_losses<br>· second_quantity</strong><br><br>Example<br>quantity_with_losses * 3.14",
          "popover_title": "Formulas",
          "remove_module": "Remove"
        },
        "index": {
          "add_description": "Creation of a new scenario for your dataset.",
          "add_title": "Add",
          "copy_description": "Add scenarios from another dataset.",
          "copy_title": "Copy",
          "delete_description": "Quickly delete multiple scenarios, filterable by type.",
          "delete_title": "Delete",
          "see_scenarios_list": "To view, edit, or delete an existing scenario, you can use the list on your right.",
          "subtitle": "Possible actions",
          "title": "Scenarios for %{name}"
        },
        "multi_destroy": {
          "confirm": "Are you sure you want to delete the selected scenarios? This action is irreversible.",
          "delete_scenarios": "Please select one or more types of scenarios to delete. The selected scenarios are those of the current version, as well as those available for all versions of the dataset.",
          "submit": "Delete",
          "subtitle": "Quick deletion",
          "title": "Scenarios for %{name}"
        },
        "new": {
          "subtitle": "New scenario",
          "title": "Scenarios for %{name}"
        },
        "scenarios_list": {
          "all": "Tous",
          "for_any_version": "Applies for any module version",
          "for_version": "Applies for version %{version}",
          "no_scenario": "No scenarios.",
          "scenarios_count": "Existing scenarios (%{count})",
          "search": "Search",
          "search_by_name": "Search by name"
        },
        "show": {
          "add": "New scenario",
          "destroy": "Delete",
          "destroy_confirm": "Do you confirm the deletion of this scenario ?",
          "edit": "Edit",
          "title": "Scenarios for %{name}"
        }
      },
      "db_modules": {
        "check": {
          "go_to_form": "Back to the form"
        },
        "check_rules": {
          "check_failed": "Some checks failed.",
          "check_run": "The following checks were run for your dataset of type",
          "check_successful": "All checks passed.",
          "mandatory": "Mandatory Rules",
          "optional": "Good Practices",
          "title": "Dataset Checks"
        },
        "edit_available_date": {
          "go_to_form": "Back to the form",
          "ignore_and_make_available": "Ignore and make available",
          "invalid_db_module": "Some information is missing.",
          "make_available": "Make available",
          "missing_information": "You still need to complete or correct the following information before you can make your dataset available:"
        },
        "edit_deprecated_date": {
          "add_substitution_dataset": "Add a new substitution dataset",
          "confirm": "Do you confirm this obsolescence? This action is irreversible.",
          "delete_substitution_dataset": "Delete",
          "deprecate_all_versions": "Deprecate all versions of this dataset.",
          "deprecate_all_versions_subtitle": "Tip: if you choose to deprecate all versions of your data, you can define substitution data to advise users in their choice of replacement.",
          "scenarios_available": {
            "one": "%{count} scenario available",
            "other": "%{count} scenarios available",
            "zero": "No scenario available"
          },
          "submit": "Submit",
          "title": "Obsolescence management"
        },
        "form": {
          "generic_publication": "Required for availability",
          "not_component_publication": "Required for availability except for a component",
          "not_uap_publication": "Required for availability, except for a process without material"
        },
        "form_for_available_date_component": {
          "confirm": "Do you confirm the availability of this item ? This action is irreversible.",
          "irreversible": "final and irreversible publication",
          "please_pick_date": "The minimum requirements defined in EIME are met (note: this check does not replace a verification).\nYour data can be released. Please select an availability date.\n",
          "submit": "Make available",
          "title": "Make available"
        },
        "form_for_multi_available_date_component": {
          "confirm": "Do you confirm the availability of these items? This action is irreversible.",
          "has_errors": "%{count_errors} dataset(s) out of %{count} cannot be released.\nPlease check the information of these datasets individually:\n",
          "irreversible": "final and irreversible publication",
          "please_pick_date": "%{count} datasets will be released:",
          "submit": "Release",
          "title": "Release multiple datasets"
        },
        "form_for_workflow_and_publication_status_component": {
          "help_content": "<strong>Working draft:</strong><p>Data set is in preliminary status of on-going development.</p>\n<strong>Final draft for internal review:</strong><p>Data set is finished and ready for internal review.</p>\n<strong>Final draft for external review:</strong><p>Data set is ready for an external review (after a potential internal review and correction if required).</p>\n<strong>Data set finalised; unpublished:</strong><p>Data set is finalised (with or without an internal and/or external review and correction if required), but it is not or not yet published.</p>\n<strong>Under revision:</strong><p>Data set is under revision and the publication of the revised data set is foreseen.</p>\n<strong>Data set finalised; entirely published:</strong><p>Data set is finalised (with or without an internal and/or external review and correction if required), and was entirely published.</p>\n",
          "help_title": "Statuses",
          "irreversible": "final and irreversible publication",
          "keep": "Keep the current version (%{ext_version})",
          "major_upgrade": "Major upgrade (%{ext_version})",
          "manual": "Choose the version manually",
          "minor_upgrade": "Minor upgrade (%{ext_version})",
          "submit": "Submit",
          "title": "Edit Status",
          "versionning_options": "Update the version (only in case of final publication)"
        },
        "multi_update_available_date": {
          "success": "Your datasets are now available."
        },
        "refresh_impacts": {
          "success": "The impacts of the module have been updated."
        },
        "update_available_date": {
          "success": "The dataset is now available."
        }
      },
      "destroy": {
        "notice": "Notice"
      },
      "error": {
        "title": "Error"
      },
      "indicators": {
        "publish": {
          "success": "The indicator has been published. Impacts are being refreshed. This operation may take several minutes."
        },
        "toggle_archive": {
          "success": "The indicator has been updated."
        }
      },
      "indicators_sets": {
        "form": {
          "create": "Create",
          "edit": "Edit indicators set",
          "new": "New indicators set",
          "published_on": "published on %{available_date}",
          "update": "Update"
        },
        "publish": {
          "success": "The indicators set has been published."
        },
        "toggle_archive": {
          "success": "The indicators set has been updated."
        }
      },
      "make_forms": {
        "already_opened": "Cannot open second form when first is opened"
      },
      "modules": {
        "information": "Information",
        "new": "Add a %{model}"
      },
      "multi_replace": {
        "replacement_report_component": {
          "error": {
            "one": "One item has not been substituted :",
            "other": "These %{count} items have not been substituted :"
          },
          "no_items_found": "No dataset corresponding to your request has been found. No substitution has been made.",
          "success": {
            "one": "One item has been substituted :",
            "other": "%{count} items have been substituted :"
          },
          "title": "You have asked to replace <strong>%{old_db_module_name}</strong> by <strong>%{new_db_module_name}</strong>."
        }
      },
      "normalizations": {
        "form": {
          "back": "Back",
          "delete": "Delete",
          "edit": "Edit",
          "factors": "Normalization Factors",
          "new": "New Normalization",
          "page_title": "Normalization for %{indicators_set}"
        },
        "index": {
          "page_title": "Normalization for %{indicators_set}"
        }
      },
      "panel_component": {
        "create": "Create",
        "update": "Update"
      },
      "partials": {
        "panel": {
          "create": "Create",
          "update": "Update"
        }
      },
      "permissions_component": {
        "change": "Change",
        "non_recursive_permissions": {
          "no_access": "No Access",
          "owner": "Owner",
          "readable": "Read-Only Access to some elements only",
          "undefined": "No Permission",
          "writable": "Access to some elements only"
        },
        "reason": {
          "admin": "automatic (administrator)",
          "inherited": "inherited from the parent folder",
          "manager": "automatic (manager)",
          "manual": "set by the owner",
          "no_perm": "unset",
          "owner": "automatic (owner)",
          "owner_manager": "automatic (manager)"
        },
        "recursive_permissions": {
          "no_access": "No Access",
          "readable": "Read-Only Access",
          "undefined": "No Permission",
          "writable": "Full Access"
        },
        "set_non_recursive_permissions": {
          "no_access": "Forbid access",
          "readable": "Read access to authorized sub-elements only",
          "writable": "Write access to authorized sub-elements only"
        },
        "set_recursive_permissions": {
          "no_access": "Forbid access",
          "readable": "Read access to all contained elements",
          "writable": "Write access to all contained elements"
        },
        "title_permissions": {
          "no_access": "Unauthorized Access",
          "readable": "Read Access",
          "writable": "Create Access"
        },
        "unset_permissions": {
          "no_access": "Stop forbidding access",
          "readable": "Drop read access",
          "writable": "Drop write access"
        }
      },
      "ponderations": {
        "form": {
          "back": "Back",
          "delete": "Delete",
          "edit": "Edit",
          "factors": "Weighting Factors",
          "new": "New weighting",
          "page_title": "Weighting for %{indicators_set}"
        },
        "index": {
          "page_title": "Weighting for %{indicators_set}"
        }
      },
      "refresh": {
        "index": {
          "refresh_instances": "Refresh Instances"
        },
        "show_instance": {
          "instance": "Instance %{name}",
          "last_refresh": "Last refresh at %{date}",
          "last_refresh_error": "Last refresh failed at %{date}",
          "last_update": "database version: %{date}",
          "number_of_flows": "%{count} flows",
          "number_of_modules": "%{count} modules",
          "refresh": "Refresh",
          "refresh_confirm": "Refreshing database is a lengthy operation and the database seems up to date, are you sure you want to continue?",
          "refresh_progress": "Refresh %{step_num}/%{step_max}: %{step_name}",
          "refresh_requested": "Refresh requested",
          "refresh_step": {
            "compute_flow_impacts": "Compute flow impacts",
            "compute_module_impacts": "Compute datasets impacts",
            "copy_immutable_impacts": "Copy immutable impacts",
            "copy_mutable_impacts": "Copy mutable impacts",
            "refresh_database": "Copying database %{table_name}",
            "remove_obsolete_impacts": "Cleaning obsolete impacts"
          },
          "up_to_date": "Database up to date"
        }
      },
      "replace": {
        "cs_modules": {
          "form_component": {
            "choose_energetic_mix": "Energetic mix",
            "quantity_action": {
              "keep": "Keep current values",
              "reset": "Take the default second quantity of the new dataset",
              "use_ratio": "Use a ratio"
            },
            "recommended": "We recommend to choose this dataset by default.",
            "replace_all_is_unavailable": "Global substitution (replace all the same elements in the case study) is not available for this dataset\nbecause the link with its original dataset is broken.\n",
            "replace_in_ref_id": {
              "add_replacement_id": "Add a location",
              "choose_cs_phase_or_container": "All the same datasets in one or more locations to select",
              "cs_case_study": "All the same datasets in this case study",
              "none": "Only this dataset"
            },
            "replace_in_ref_id_label": "Substitute",
            "submit": "Substitute",
            "suggested_substitutions": "Suggested substitutions",
            "tooltip_formula": "You can fill a formula in this field with the four common operations (+, -, *, /) as well as common mathematical functions. For some formula fields, variables are available."
          },
          "help": {
            "energetic_mix": "Energy mixes are inseparable from their original module. If your new module is configurable, you must reassign it an energy mix.",
            "label_energetic_mix": "Energy mix",
            "label_substitutions": "Suggestions",
            "label_units": "Units",
            "net_calorific_value": "If existing, the lower calorific value is automatically replaced by that of the new data.",
            "quantity": "The quantity of your module is retained by default. You can also apply a ratio, for example if the unit group of the new data differs from the old one. The ratio will be preserved by keeping your original formula: '(original_formula) * (ratio)'.",
            "renewable_percentage": "If existing, the percentage of renewable material value is automatically replaced by the new data value.",
            "second_quantity": "Like the main quantity, you can keep the value or apply a ratio. You can also choose to apply the default value of the new data. In this case, it will overwrite your old value.",
            "substitutions": "Whenever possible, we suggest replacement data for obsolete data.\nPlease note the points of caution in the comments.\n",
            "units": "If the unit groups (mass, metric...) required by the new data differ from the old one, the module will be assigned the default units of the new unit groups."
          },
          "replace": {
            "title": "Substitute"
          }
        },
        "cs_transport_steps": {
          "form_component": {
            "no_ratio_for_transport_steps": "Please note that automatic application of ratios is not possible for transport steps.",
            "origin_dataset": "Origin dataset",
            "recommended": "We recommand to choose this dataset by default.",
            "replace_all_is_unavailable": "Global substitution (replace all the same elements in the case study) is not available for this transport\nbecause the link with its original dataset is broken.\n",
            "replace_in_ref_id": {
              "add_replacement_id": "Add a location",
              "choose_cs_phase_or_container": "All the same transports in one or more locations to select",
              "cs_case_study": "All the same transports in this case study",
              "none": "Only this transport"
            },
            "replace_in_ref_id_label": "Substitute",
            "replacement_dataset": "Replacement dataset",
            "submit": "Substitute",
            "suggested_substitutions": "Suggested substitutions"
          },
          "help": {
            "label_load_rates": "Average load and empty return percentages",
            "label_other_attributes": "Total transported mass, distance, and rate",
            "label_substitutions": "Suggestions",
            "load_rates": "You can fill in these fields if you are switching from air, sea, or rail transport to road transport.\nYou can also leave the default values.\n",
            "other_attributes": "During substitution, these parameters will remain unchanged.",
            "substitutions": "Whenever possible, we suggest replacement data for obsolete data.\nPlease note the points of caution in the comments.\n"
          },
          "replace": {
            "title": "Substitute"
          }
        }
      },
      "statuses": {
        "create": {
          "success": "Success"
        }
      },
      "templates_collection": {
        "create": {
          "notice": "The case study has been defined as global template."
        },
        "destroy": {
          "notice": "The case study has been removed from global templates."
        }
      },
      "update": {
        "notice": "Notice"
      },
      "users_cs_item": {
        "update": "Update"
      },
      "users_cs_items": {
        "create": {
          "notice": "Notice"
        },
        "permission_remove": "Remove permission",
        "update_all": {
          "notice": "Permissions were updated.",
          "protection_error": "It's not possible to set permissions for project owner %{name}."
        }
      }
    },
    "no_results": "No results.",
    "ok": "OK",
    "project": {
      "actions": {
        "archive": {
          "name": "Archive / Unarchive",
          "shortcut": "Maj + A"
        },
        "bookmark": {
          "name": "Bookmark",
          "shortcut": "Shortcut"
        },
        "copy_item": {
          "name": "Copy",
          "shortcut": "Maj + C"
        },
        "cut_item": {
          "name": "Cut",
          "shortcut": "Maj + X"
        },
        "delete_item": {
          "name": "Delete",
          "shortcut": "Del"
        },
        "duplicate": {
          "name": "Duplicate",
          "shortcut": "Maj + D"
        },
        "edit_item": {
          "name": "Edit",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "Rename",
          "shortcut": "E"
        },
        "export": {
          "name": "Export",
          "shortcut": "Shortcut"
        },
        "export_analysis": {
          "name": "Export analysis",
          "shortcut": "Shortcut"
        },
        "export_design": {
          "name": "Export design",
          "shortcut": "Shortcut"
        },
        "export_eime": {
          "name": "Export to EIME format",
          "shortcut": "Shortcut"
        },
        "export_inies": {
          "name": "Export to INIES format",
          "shortcut": "Shortcut"
        },
        "export_pep_ecopassport": {
          "name": "Export to PEP Ecopassport format",
          "shortcut": "Shortcut"
        },
        "go_to_analysis": {
          "name": "Go to analysis",
          "shortcut": "A"
        },
        "go_to_comparison": {
          "name": "Go to comparison",
          "shortcut": "Shortcut"
        },
        "go_to_design": {
          "name": "Go to design",
          "shortcut": "D"
        },
        "import": {
          "name": "Import a case study",
          "shortcut": "Shortcut"
        },
        "paste_item": {
          "name": "Paste",
          "shortcut": "Maj + P"
        },
        "remove_global_template": {
          "name": "Remove from global templates"
        },
        "share": {
          "name": "Share",
          "shortcut": "Shortcut"
        },
        "status": {
          "name": "Status",
          "shortcut": "Shortcut"
        },
        "transform_to_template": {
          "name": "Transform to template",
          "shortcut": "Maj + T"
        },
        "unarchive": {
          "name": "Unarchive / Archive",
          "shortcut": "Maj + A"
        },
        "unmark_as_template": {
          "name": "Unmark as template"
        }
      },
      "add": {
        "case_study": {
          "name": "New case study",
          "shortcut": "Maj + C"
        },
        "folder": {
          "name": "New folder",
          "shortcut": "Maj + D"
        },
        "project": {
          "name": "New project",
          "shortcut": "Maj + P"
        }
      },
      "cs_case_studies": {
        "bookmark": {
          "add": "This case study has been marked as favorite. You can find it in the \"System\" menu",
          "remove": "This case study has been removed from favorites."
        },
        "create": {
          "notice": "Creating the case study in progress."
        },
        "destroy": {
          "notice": "The case study is successfully deleted"
        },
        "indicators_set": {
          "error": "The indicator set could not be changed.",
          "notice": "The indicator set has been changed."
        },
        "share": {
          "add": "Case studies have been successfully shared. You can find it in the \"System\" menu",
          "remove": "Case sharing has been cancelled."
        },
        "update": {
          "notice": "The case study is modified with success."
        }
      },
      "cs_case_study_statuses": {
        "back": "Close",
        "create": {
          "success": "The change of status of the case study has been taken into account."
        },
        "submit": "Valid"
      },
      "cs_projects": {
        "reject_edit": "You are not allowed to modify this project",
        "reject_insert": "You are not allowed to create a project"
      },
      "delete_confirm": "Are you sure to delete this/these item (s)?",
      "delete_denied": "It is not possible to destroy non empty projects.",
      "details": {
        "analysis": "Analysis",
        "creation": "Creation",
        "creation_type": "Creation type",
        "database": "Database",
        "db_module_released_at": "Version",
        "db_module_released_at_unset": "Latest by default",
        "default_template": "%{name} (default)",
        "functional_unit": "Functional unit",
        "inies": "INIES information",
        "less_info": "Less information",
        "more_info": "More information",
        "notes": "Notes",
        "permissions": "Permissions",
        "title": "Details",
        "unset": "Unset"
      },
      "display": {
        "visible_columns": "Visible columns"
      },
      "filter_type": {
        "ecobilan_all": "Ecobilan in all projects",
        "ecobilan_current": "Ecobilan in current project or folder",
        "name_all": "Name in all projects",
        "name_current": "Name in current project or folder"
      },
      "filter_user": {
        "all": "All",
        "default": "Default",
        "label": "Filter by user :"
      },
      "global": {
        "import": {
          "name": "Import",
          "shortcut": "Shortcut"
        }
      },
      "index": {
        "title": "My projects"
      },
      "items_filter_component": {
        "filter_by": "Filter by",
        "search": "Search",
        "update": "Update"
      },
      "library": {
        "clear": "Clear",
        "search": "Search"
      },
      "overview": {
        "badges": {
          "instance_template": "instance template"
        },
        "columns": {
          "badges": {
            "db_locked": "The database is locked on a fixed date",
            "read_only": {
              "description": "Read only : you are not the owner",
              "text": "read only"
            },
            "templated": "<p><string>Templated</string></p>\n<p>This case study can be used as a template for new case studies. To be available on the case study creation form, it must be added to the project first.</p>\n"
          },
          "bookmark_icon": "Bookmark",
          "buttons": "Actions",
          "comments": "Comments",
          "created_at": "Created At",
          "db_module_released_at": "Modules date",
          "ico": "Ico",
          "id": "Id",
          "name": "Name",
          "path": "Path",
          "rank": "Rank",
          "share_icon": "Share",
          "state": "State",
          "status": "Status",
          "team": "Team",
          "updated_at": "Updated At",
          "user": "Owner"
        }
      },
      "search": {
        "clear": "Clear",
        "placeholder": "Search",
        "search_elements": "Search elements",
        "submit": "Search",
        "tooltip": ""
      },
      "virtual_root": "My projects",
      "virtual_root_archived": "My archived projects"
    },
    "ui": {
      "flying_notifications_component": {
        "dismiss": "Dismiss"
      },
      "interactive_breadcrumb": {
        "breadcrumb": {
          "clear": "Clear"
        }
      },
      "interactive_breadcrumb_category_component": {
        "clear": "Clear"
      },
      "toggle_panel_bar_component": {
        "maximize": "Maximize side panel",
        "minimize": "Minimize side panel"
      }
    }
  },
  "fr": {
    "admin": {
      "actions": {
        "add": {
          "company": "Entreprise",
          "instance": "Instance",
          "user": "Utilisateur"
        },
        "archive": {
          "name": "Archiver"
        },
        "delete_item": {
          "name": "Supprimer",
          "shortcut": "Del"
        },
        "duplicate": {
          "name": "Dupliquer",
          "shortcut": "Maj + D"
        },
        "edit_expiration_date": {
          "name": "Editer la date d'expiration",
          "shortcut": "Maj + X"
        },
        "edit_item": {
          "name": "Editer",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "Renommer"
        },
        "edit_line_admin": {
          "name": "Editer la ligne",
          "shortcut": "E"
        },
        "edit_manager": {
          "name": "Editer le manager",
          "shortcut": "M"
        },
        "edit_managers": "Editer les managers",
        "reactiv_license": {
          "name": "Modifier la date d'expiration de la licence"
        },
        "unarchive": {
          "name": "Désarchiver"
        }
      },
      "add": {
        "company": {
          "name": "Nouvelle Entreprise",
          "shortcut": "Raccourci"
        },
        "instance": {
          "name": "Nouvelle Instance",
          "shortcut": "Raccourci"
        },
        "user": {
          "name": "Nouveau Utilisateur",
          "shortcut": "Raccourci"
        }
      },
      "communication": {
        "create": {
          "success_message": "La communication a été créée avec succès."
        },
        "destroy": {
          "failure_message": "La communication n'a pu être supprimée.",
          "success_message": "La communication %{name} a été supprimée."
        },
        "update": {
          "success_message": "La communication a été modifiée avec succès."
        }
      },
      "communications": {
        "partials": {
          "toolbar": {
            "refresh": "Communications",
            "refresh_confirm": "Rafraîchir les tables: %{tables}",
            "refresh_title": "Rafraîchir toutes les communications"
          }
        }
      },
      "company": {
        "create": {
          "success_message": "L'entreprise a été créé avec succès."
        },
        "destroy": {
          "failure_message": "L'entreprise n'a pu être supprimée.",
          "success_message": "L'entreprise %{name} a été supprimée."
        },
        "update": {
          "success_message": "L'entreprise a été modifiée avec succès."
        }
      },
      "delete_confirm": "Êtes-vous sûr de vouloir supprimer ce(s) élément(s) ?",
      "details": {
        "title": "Détails"
      },
      "instances": {
        "archive_instance": "Instances archivées",
        "create": {
          "success_message": "L'instance a été créé avec succès."
        },
        "destroy": {
          "failure_message": "L'instance n'a pu être supprimée.",
          "success_message": "L'instance %{name} a été supprimée."
        },
        "root_instance": "Instances",
        "toggle_archive": {
          "success_message": "L'instance a bien été mise à jour."
        },
        "update": {
          "success_message": "L'instance a été modifiée avec succès."
        }
      },
      "overview": {
        "columns": {
          "communication": {
            "name": "Nom de la communication"
          }
        }
      },
      "partials": {
        "toolbar": {
          "refresh": "Utilisateurs",
          "refresh_confirm": "Rafraîchir les tables : %{tables}",
          "refresh_title": "Rafraîchir tous les utilisateurs"
        }
      },
      "refresh": {
        "refresh_success": "Base de donnée rafraîchie"
      },
      "refresh_users": {
        "refresh_success": "Base de donnée rafraîchie"
      },
      "toolbar": {
        "search": "Recherche"
      },
      "user": {
        "create": {
          "success_message": "L'utilisateur a été créé avec succès."
        },
        "default_language": {
          "english": "Anglais",
          "french": "Français"
        },
        "destroy": {
          "failure_message": "L'utilisateur n'a pu être supprimé.",
          "success_message": "Utilisateur supprimé avec succès."
        },
        "update": {
          "success_message": "L'utilisateur a été modifié avec succès."
        }
      },
      "users": {
        "edit_expiration_date": {
          "title": "Mise à jour de dates d'expiration"
        },
        "edit_manager": {
          "title": "Modifier le(s) manager(s)"
        },
        "partials": {
          "details_item": {
            "empty_partners": "Pas d'équipe."
          }
        },
        "update_expiration_date": {
          "success": "Mise à jour effectuée."
        },
        "update_manager": {
          "success": "Mise à jour effectuée."
        }
      }
    },
    "analysis": {
      "abs_sum": "Somme des valeurs absolues",
      "both": "ℝ %",
      "broken_message": "Le cas d'étude comprend des éléments cassés qui faussent les résultats, veuillez les réparer.",
      "change": "Changer",
      "charts": "Graphiques",
      "compare": "Comparaison",
      "copy": "Copier",
      "decimal": {
        "text": "0.00",
        "title": "Notation Decimale"
      },
      "display": {
        "gross_and_percent_values": "Afficher les valeurs brutes et les pourcentages",
        "gross_values": "Afficher les valeurs brutes",
        "hidden_items_excluded_from_sum": "Les éléments cachés ne participent pas à la somme",
        "indicators": "Indicateurs",
        "normalized_values": "Afficher les valeurs normalisées",
        "path": "Voir le chemin",
        "percent_values": "Afficher les pourcentages",
        "show_full_indicator_names": "Afficher les noms complets des indicateurs",
        "weighted_values": "Afficher les valeurs pondérées",
        "zero_values": "Lignes à 0"
      },
      "download_as_csv": "Télécharger au format CSV",
      "download_as_excel": "Télécharger au format Excel",
      "error_displaying_results_message": "Une erreur a eu lieu à l'affichage, essayez de recalculer.",
      "expand_table": "Agrandir/réduire le tableau",
      "export": {
        "current_table": "Exporter le tableau courant"
      },
      "go_to_container": "Aller au containeur selectionné",
      "gross": "ℝ",
      "hidden": "Masqués",
      "indicator_flow_component": {
        "flow": "Flux",
        "flow_hidden": "Flux (%{hidden} masqués)",
        "negative_sum": "Somme (sous-total des valeurs négatives)",
        "others": "Autres",
        "others_negative_subtotal": "Autres (sous-total des valeurs négatives)",
        "others_positive_subtotal": "Autres (sous-total des valeurs positives)",
        "positive_sum": "Somme (sous-total des valeurs positives)",
        "sum": "Somme",
        "unit": "Unité",
        "weighting_factor": "Facteur de pondération"
      },
      "indicator_tree_component": {
        "edit_normalization": "(modifier)",
        "hide_row": "Exclure la ligne des résultats",
        "normalization": "Normalisation :",
        "normalization_none": "Pas de normalisation",
        "ponderation": "Pondération :",
        "ponderation_none": "Pas de pondération",
        "show_row": "Inclure la ligne dans les résultats",
        "submit_normalization": "Normaliser",
        "track": "Voir les contributions dans le design"
      },
      "indicators": "Indicateurs",
      "indicators_impacts_by_dataset_component": {
        "column_80percent": "80%",
        "ecobilan": "Ecobilan",
        "indicators": "Indicateurs",
        "module": "Module",
        "no_threshold": "Pas de seuil",
        "other": "Autres (%{num_items} modules)",
        "other_dataset": "Autre: %{name}",
        "other_negative": "dont valeurs négatives",
        "other_positive": "dont valeurs positives",
        "phase_name": "Phase",
        "phases": "Phases",
        "sum": "Somme des valeurs absolues",
        "threshold": "Seuil",
        "with_energetic_mix": "+"
      },
      "indicators_set_informations": "Informations",
      "indicators_set_results_tabs_component": {
        "impacts_by_dataset": "Contributions - Modules",
        "normalization_and_weightings": "Normalisation & pondération",
        "results_by_item": "Contributions - Cycle de vie"
      },
      "indicators_sets": {
        "spreadsheet": {
          "normalized": "Normalisé",
          "weighted": "Pondéré"
        }
      },
      "informations": "<p>Pour lancer un calcul :</p>\n  <p class='ms-5'>1. Cliquer sur l'icône <i class=\"fa-regular fa-circle-play\"></i></p>\n  <p class='ms-5'>2. Attendre que l'icône passe au vert <i class=\"fa-solid fa-circle text-success\"></i></p>\n  <p class='ms-5'>3. Cliquer sur le nom pour afficher les résultats.</p>\n  <p class='mt-4'>Si l'icône est jaune <i class=\"fa-solid fa-circle text-warning\"></i> vos résultats ne sont plus à jour. Cliquer sur l'icône <i class=\"fa-regular fa-circle-play\"></i> pour recalculer.</p>\n",
      "name": "Nom",
      "negative_others": "Autres négatifs\"",
      "negative_others_contains": "Autres négatifs",
      "negative_subtotal": "Sous total négatif",
      "no_parameters_set": "Aucun set de paramètres.",
      "normalized_indicators_table_component": {
        "characterisation": "Caractérisation",
        "edit_normalization": "(modifier)",
        "indicator": "Indicateur",
        "norm_factor": "Facteur",
        "norm_percent": "Ratio",
        "norm_value": "Résultat",
        "normalization": "Normalisation",
        "normalization_none": "Pas de normalisation",
        "normalized_percentage_major": "Ratio de normalisation (%) - plus de 80%",
        "normalized_percentage_minor": "Ratio de normalisation (%) - moins de 20%",
        "show_phases": "Afficher les phases",
        "submit_normalization": "Valider",
        "sum": "Somme",
        "sum_all_phases": "Somme",
        "sum_with_module_d": "Somme (avec module D)",
        "sum_with_phases": "Somme (%{num_enabled_phases}/%{num_phases} phases)",
        "sum_without_module_d": "Somme (sans module D)",
        "unit": "Unité",
        "weighted_percentage_major": "Ratio de pondération (%) - plus de 80%",
        "weighted_percentage_minor": "Ratio de pondération (%) - moins de 20%",
        "weighted_value": "Résultat",
        "weighting": "Pondération",
        "weighting_factor": "Facteur",
        "weighting_none": "Pas de pondération",
        "weighting_percent": "Ratio"
      },
      "options": "Options",
      "others": "Autres",
      "out_of_date_results_message": "Ce résultat d'analyse est obsolète, merci de le recalculer",
      "overview": {
        "columns": {
          "flow": "Flux",
          "indicator": "Indicateur",
          "name": "Nom",
          "negative_sum": "Somme négative",
          "path": "Chemin",
          "positive_sum": "Somme positive",
          "sum": "Somme",
          "unit": "Unité",
          "unit_name": "Unité facteur de pondération",
          "weighting_factor": "Facteur de pondération"
        },
        "titles": {
          "indicator": "Indicateur",
          "unit_name": "Unité",
          "weighting_factor": "Facteur"
        }
      },
      "parameters_set_enabled": "Set de paramètres actif : %{set}",
      "percentage": "%",
      "positive_others": "Autres positifs",
      "positive_others_contains": "Autres positifs",
      "positive_subtotal": "Sous total positif",
      "ratio": "Ratio : %{ratio}",
      "result_set_computation_date_component": {
        "item_not_computed": "%{item}: non calculé",
        "item_outdated": "%{item}: plus à jour, il date du %{date}",
        "item_up_to_date": "%{item}: calcul à jour",
        "not_computed": "Certains éléments manquent au calcul",
        "outdated": "Le calcul n'est plus à jour. Il date du %{date}.",
        "up_to_date": "Le calcul est à jour (%{date})"
      },
      "scientific": {
        "text": "10<sup>n</sup>",
        "title": "Notation Scientifique"
      },
      "settings": "Réglages",
      "show_broken": "Voir les éléments cassés",
      "step": "Étape",
      "sum": "Somme",
      "threshold": {
        "phase": "Phase",
        "text": "Seuil",
        "title": "Appliquer un seuil en pourcentage afin de réunir ensemble les valeurs inférieures à celui-ci."
      },
      "total": "Total",
      "total_others": "Autres",
      "total_others_contains": "Autres",
      "tree": {
        "abbreviation": "Abréviation",
        "calculate": "Calculer",
        "method": "Méthode",
        "name": "Nom complet",
        "normalization_and_weightings": "Normalisation et pondération",
        "select": "Selectionner pour calculer",
        "select_all": "Tout sélectionner",
        "source": "Source",
        "unit_name": "Unité",
        "year": "Année"
      },
      "values": "Valeurs"
    },
    "cancel": "Annuler",
    "close": "Fermer",
    "delete": "Supprimer",
    "design": {
      "actions": {
        "back_to_parent": "Retour à l'élément parent",
        "collapse": "Replier un élément <kbd>←</kbd>",
        "compare_item": {
          "name": "Comparer"
        },
        "copy": "复制 <kbd>shift + C</kbd>",
        "copy_item": {
          "name": "Copier",
          "shortcut": "Maj + C"
        },
        "cut": "剪切 <kbd>shift + X</kbd>",
        "cut_item": {
          "name": "Couper",
          "shortcut": "Maj + X"
        },
        "delete": "删除 <kbd>Del</kbd>",
        "delete_item": {
          "name": "Supprimer",
          "shortcut": "Del"
        },
        "edit": "编辑 <kbd>shift + E</kbd>",
        "edit_item": {
          "name": "Editer",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "Éditer la ligne",
          "shortcut": "E"
        },
        "enter": "Entrer dans un élément <kbd>&crarr;</kbd>",
        "expand": "Déployer un élément <kbd>→</kbd>",
        "fix_broken": {
          "name": "Réparer les modules cassés"
        },
        "in_library": "Dans la région librairie",
        "left_region": "Se déplacer d'une région vers la gauche<kbd>Maj + Alt + ←</kbd>",
        "navigate_down": "Déplacer la selection vers le bas <kbd>↓</kbd>",
        "navigate_up": "Déplacer la selection vers le haut <kbd>↑</kbd>",
        "navigation": "Navigation avec la selection",
        "next_tab": "Changer d'onglet vers la droite <kbd>Maj + Alt + ↑</kbd>",
        "paste": "粘贴 <kbd>shift + P</kbd>",
        "paste_item": {
          "name": "Coller",
          "shortcut": "Maj + P"
        },
        "previous_tab": "Changer d'onglet vers la gauche <kbd>Maj + Alt + ↓</kbd>",
        "region": "Navigation par régions",
        "reload": "Recharger",
        "replace": "Substituer",
        "right_region": "Se déplacer d'une région vers la droite<kbd>Maj + Alt + →</kbd>",
        "switch_down": "Se déplacer d'une région vers le bas<kbd>Maj + Alt + ↓</kbd>",
        "switch_up": "Se déplacer d'une région vers le haut <kbd>Maj + Alt + ↑</kbd>"
      },
      "add": {
        "dossier": {
          "name": "Ajouter un dossier",
          "shortcut": 1
        },
        "energy_consumption": {
          "name": "Ajouter une consommation d'énergie",
          "shortcut": 5
        },
        "folder": {
          "name": "Add a folder",
          "shortcut": "1"
        },
        "part": {
          "name": "Ajouter une pièce",
          "shortcut": 3
        },
        "phase": {
          "name": "Ajouter une phase",
          "shortcut": 0
        },
        "subassembly": {
          "name": "Ajouter un sous ensemble",
          "shortcut": 2
        },
        "transport_step": {
          "name": "Ajouter une étape de transport de marchandise",
          "shortcut": 4
        }
      },
      "add_elements": "Ajout d'un élément",
      "cs_flows": {
        "create": {
          "notice": "Le flux a été ajouté avec succès."
        },
        "destroy": {
          "notice": "Le flux a été supprimé avec succès."
        },
        "update": {
          "notice": "Le flux a été modifié avec succès."
        }
      },
      "cs_items": {
        "reject_if_cs_item_not_exist": {
          "reject": "Rejecter"
        }
      },
      "cs_modules": {
        "create": {
          "notice": "Le module a été ajouté avec succès."
        },
        "destroy": {
          "notice": "Le module a été supprimé avec succès."
        },
        "update": {
          "notice": "Le module a été modifié avec succès."
        }
      },
      "cs_phases": {
        "create": {
          "notice": "La phase a été ajoutée avec succès."
        },
        "destroy": {
          "notice": "Le phase a été supprimée avec succès."
        },
        "update": {
          "notice": "La phase a été modifiée avec succès."
        }
      },
      "delete_confirm": "Êtes-vous sûr de vouloir supprimer ce(s) élément(s) ?",
      "display": {
        "visible_columns": "Colonnes visibles"
      },
      "elements_actions": "Actions sur un élément",
      "items_filter_component": {
        "broken_modules": "Modules cassés",
        "families": "Familles",
        "item_types": "Type d'éléments",
        "module_types": "Type de modules",
        "obsolescence": "Obsolescence",
        "phases": "Phases",
        "reset": "Réinitialiser",
        "search": "Recherche",
        "update": "Mettre à jour"
      },
      "library": {
        "add": "Ajouter",
        "clear": "Effacer",
        "deprecated_since": "Obsolète depuis le %{date}",
        "deprecated_soon": "Donnée bientôt obsolète",
        "favorites": "Favoris",
        "filter": {
          "family": "Famille"
        },
        "flat_version_template": "%{name} (v%{version})",
        "flows": "Flux",
        "included_versions": "(incluant les différentes versions)",
        "info": "Information",
        "latest_module_version_template": "Version %{version} (dernière) : %{date}",
        "module": "Module",
        "module_version_template": "Version %{version} : %{date}",
        "modules": "Modules",
        "no_results": "Aucun résultat",
        "search": "Rechercher",
        "search_favorites": "Recherche de favoris…",
        "search_favorites_title": "Recherche de favoris, les opérateurs tels que AND, OR, NOT sont utilisables, ainsi que les \"\" et les ()",
        "search_flows": "Recherche de flux…",
        "search_flows_title": "Recherche de flux, les opérateurs tels que AND, OR, NOT sont utilisables, ainsi que les \"\" et les ()",
        "search_modules": "Recherche de modules…",
        "search_modules_title": "Recherche de modules, les opérateurs tels que AND, OR, NOT sont utilisables, ainsi que les \"\" et les ()",
        "search_systems": "Recherche de systèmes…",
        "search_systems_title": "Recherche de systèmes, les opérateurs tels que AND, OR, NOT sont utilisables, ainsi que les \"\" et les ()",
        "shared_by": "%{item_name} - partagé par %{user_name}",
        "systems": "Systèmes"
      },
      "name": "Nom",
      "overview": {
        "columns": {
          "badges": {
            "reusable": "<p><strong>Réutilisable</strong></p>\n<p>Un bien ou un composant est réutilisable si, lors de la fin de vie du produit, ce composant peut être réutilisé dans sa même fonction ou une autre fonction sans transformation de la matière contenue</p>\n",
            "use_as_process": "<p><strong>Utilisé en tant que procédé</strong></p>\n<p>Se dit d’un matériau ou d’un composant consommé pendant le processus de fabrication d’un bien, et qui ne se retrouve pas dans la composition matière de ce bien</p>\n"
          },
          "category_with_inheritance": "Catégorie",
          "comments": "Com.",
          "computed_quantity": "Quantité cum.",
          "created_at": "Date de création",
          "ecobilan_identifier": "Eco. Id",
          "ico": "Ico",
          "id": "EIME Identifiant",
          "loss_rate_percentage": "Pourcentage du taux de perte",
          "lr": "TP",
          "name": "Nom",
          "net_calorific_value": "PCI",
          "path": "Chemin",
          "quantity": "Quantité",
          "quantity_formula": "Formule de quantité",
          "rank": "#",
          "renewable_p": "MR",
          "second_quantity": "Sec. Qua.",
          "state": "État",
          "titles": {
            "category_with_inheritance": "Catégorie (avec héritage)",
            "comments": "Commentaire [Com.]",
            "computed_quantity": "Quantité cumulée",
            "created_at": "Créé à",
            "ecobilan_identifier": "Ecobilan Identifiant [Eco. Id]",
            "ico": "Icon [Ico]",
            "id": "Id",
            "loss_rate_percentage": "Pourcentage du taux de perte",
            "lr": "Taux de Perte (%) [TP]",
            "name": "Nom",
            "net_calorific_value": "Pouvoir calorifique inférieur [PCI]",
            "path": "Chemin",
            "quantity": "Quantité",
            "rank": "Position [#]",
            "renewable_p": "Matière renouvelable (%) [MR]",
            "second_quantity": "Seconde Quantité [Sec. Qua.]",
            "state": "Etat",
            "tracking_gross": "Suivi brut",
            "tracking_percent": "Pourcentage de suivi",
            "updated_at": "Mis à jour à",
            "use_as_process": "Utilisation durant le procédé [UDP]"
          },
          "tracking": "Ciblage",
          "tracking_gross": "Ciblage",
          "tracking_percent": "Ciblage (%)",
          "updated_at": "Date de modification",
          "use_as_process": "UDP"
        }
      },
      "partials": {
        "tracking_button": {
          "flows": "Flux",
          "none": "Supprimer le tracking courant",
          "relative_to_case_study": "Pourcentage relatif au cas d'étude",
          "relative_to_phase": "Pourcentage relatif à la phase",
          "relative_to_view": "Pourcentage relatif à la vue courante"
        }
      },
      "replace": {
        "all": "Substituer tous les mêmes éléments du cas d'étude.",
        "btn": "Substituer",
        "db_flow_uuid": "ext_id du flux, par ex: f54a4bc1-68ef-4332-a1a2-760ad5b72168",
        "errors": {
          "db_item_not_found": "Aucun élément n'a été trouvé avec cet identifiant : %{id}",
          "db_item_not_provided": "Veuillez renseigner une nouvelle donnée.",
          "replace_fail": "La substitution a échouée, veuillez réessayer ou contacter le support EIME."
        },
        "new": "Nouveau",
        "previous": "Précédent",
        "replace_all_is_unavailable": "La substitution globale (remplacement de tous les mêmes éléments dans le cas d'étude) n'est pas disponible pour cet élément.",
        "title": "Substituer un élément"
      },
      "search": {
        "search_elements": "Recherche dans le cas d'étude…"
      },
      "search_case_study": "Rechercher dans le cas d'étude…",
      "searches": {
        "case_study": "Rechercher dans le cas d'étude <kbd>Maj + f </kbd>",
        "library": "Rechercher dans la librairie active <kbd>f<kbd>",
        "project": "Rechercher dans un projet <kbd>Maj + Alt + f<kbd>",
        "title": "Recherches"
      },
      "shortcuts": "Raccourcis clavier",
      "show_shortcuts": "Afficher les raccourcis <kbd>Maj + ?</kbd>",
      "tracking_off": "Contributions",
      "tracking_on": "Contributions pour %{indicator_name}",
      "tree": {
        "containers": "conteneur(s)",
        "expand_all": "Etendre l'arborescence"
      }
    },
    "front": {
      "actions": {
        "confirm": {
          "archive_database_upgrade_chronicle": "Confirmez-vous que vous souhaitez archiver cette mise à jour ? Toutes les mises à jour effectuées avant celle-ci seront également archivées, si elles ne le sont pas déjà.",
          "delete_database_upgrade_step": {
            "one": "⚠️ Une donnée est actuellement associée à cette étape. Si vous supprimez cette étape, cette donnée sera retirée du processus de mise à jour automatique. Confirmez-vous la suppression ?",
            "other": "⚠️ %{count} données sont actuellement associées à cette étape. Si vous la supprimez, ces données seront retirées du processus de mise à jour automatique. Confirmez-vous la suppression ?",
            "zero": "Confirmez-vous la suppression ? Le risque de cette opération est faible car aucune donnée n'est associée à cette étape."
          },
          "delete_item": "Êtes-vous sûr de vouloir supprimer ce(s) élément(s) ?",
          "launch_database_upgrade_step": "Étape sélectionnée: %{name}. Confirmez-vous le lancement de cette mise à jour ?",
          "make_available": "Confirmez-vous mise à disposition de cet élément ? Celui-ci sera disponible dès aujourd'hui. Cette action est irréversible.",
          "prune_items": "Voulez-vous supprimer tous les éléments dont la quantité est définie à zéro ?"
        },
        "errors": {
          "contact_support": "Une erreur est survenue, merci de contacter le support EIME.",
          "unauthorized": "Vous n'êtes pas autorisé à faire cette action."
        },
        "name": {
          "add_case_study": "Ajouter un cas d'étude",
          "add_category": "Ajouter une catégorie",
          "add_company": "Ajouter une entreprise",
          "add_database_upgrade_step": "Ajouter une étape",
          "add_db_module_substitution": "Définir une substitution",
          "add_dossier": "Ajouter un dossier",
          "add_energy_consumption": "Ajouter une consommation d'énergie",
          "add_flow": "Ajouter un flux",
          "add_indicator": "Ajouter un indicateur",
          "add_indicators_set": "Ajouter un set d'indicateur",
          "add_instance": "Ajouter une instance",
          "add_item": "Ajouter un élément",
          "add_linked_module": "Ajouter en tant que module lié",
          "add_linked_module_types": {
            "end_of_life": "Fin de vie",
            "linked_process": "Processus",
            "module_d": "Module D"
          },
          "add_module": "Créer un module",
          "add_module_version": "Nouvelle version",
          "add_part": "Ajouter une pièce",
          "add_phase": "Ajouter une phase",
          "add_project": "Ajouter un projet",
          "add_subassembly": "Ajouter un sous-ensemble",
          "add_tag": "Créer un tag",
          "add_transport_step": "Ajouter une étape de transport de marchandise",
          "add_user": "Ajouter un utilisateur",
          "archive_item": "Archiver",
          "bookmark": "Favori",
          "cancel_database_upgrade_chronicle": "Annuler cette mise à jour",
          "check": "Vérifier la donnée",
          "compare_db_modules": "Comparer",
          "copy_item": "Copier",
          "copy_ref_id": "Copier le ref id",
          "cut_item": "Couper",
          "define_global_template": "Ajouter aux templates d'instance",
          "delete_item": "Supprimer",
          "deprecate": "Rendre obsolète",
          "download_case_study_source": "Télécharger le cas d'étude source",
          "duplicate": "Dupliquer",
          "duplicate_item": "Dupliquer un élement",
          "edit_contributors": "Modifier les contributeurs",
          "edit_expiration_date": "Éditer la date d'expiration",
          "edit_icv": "Modifier l'ICV",
          "edit_item": "Modifier",
          "edit_line": "Éditer la ligne",
          "edit_manager": "Éditer le manager",
          "edit_normalization": "Modifier les normalisations",
          "edit_parameters": "Paramètres",
          "edit_ponderation": "Modifier les pondérations",
          "edit_rank": "Modifier le rang",
          "edit_scenarios": "Modifier les scénarios",
          "edit_tokens": "Modifier les tokens",
          "edit_workflow_and_publication_status": "Statut",
          "export": {
            "analysis": "Analyse (avancée)",
            "analysis_json": "Analyse (JSON avancé)",
            "comparison": "Comparaison",
            "design": "Design",
            "eime": "Eime",
            "inies": "Inies",
            "json_case_study": "Design JSON",
            "multi_tracking": "Design (tous les trackings)",
            "name": "Export",
            "pep_ecopassport": "PEP Ecopassport",
            "simplified_analysis": "Analyse",
            "simplified_analysis_json": "Analyse (JSON)",
            "tracking": "Design (avec tracking courant)"
          },
          "export_database_upgrade_chronicle": "Exporter le rapport de changement",
          "export_module": "Exporter",
          "find_in_library": "Rechercher dans la bibliothèque",
          "fix_broken": "Réparer les éléments cassés",
          "forward": "Transférer",
          "go_to_comparison": "Aller à la comparaison",
          "import_case_study": "Importer un cas d'étude",
          "import_case_study_here": "Importer un cas d'étude dans ce dossier",
          "import_module": "Importer des modules",
          "info_item": "Informations",
          "launch_database_upgrade_step": "Lancer cette mise à jour",
          "make_available": "Mettre à disposition",
          "mark_as_favorite": "Ajouter aux favoris",
          "paste_item": "Coller",
          "paste_item_here": "Coller dans cet élément",
          "permissions": "Permissions",
          "prune_items": "Nettoyer l'arborescence",
          "recompute_broken": "Recalculer les éléments cassés",
          "refresh_children": "Rafraîchir la base de données des instances filles",
          "refresh_module_impacts": "Calculer les impacts",
          "reinitialize": "Réinitialiser l'état",
          "remove_analysis_results": "Supprimer les calculs d'analyse",
          "remove_from_favorite": "Enlever des favoris",
          "remove_global_template": "Enlever des templates d'instance",
          "replace_cs_modules": "Modules",
          "replace_cs_transport_steps": "Étapes de transport",
          "replace_item": "Substituer",
          "reset_item_path": "Recalcul des item_path",
          "share": "Partager",
          "status": "Statut",
          "transform_to_module": "Transformer en module",
          "transform_to_template": "Ajouter aux modèles",
          "unarchive_item": "Désarchiver",
          "unmark_as_template": "Enlever des modèles",
          "unshare": "Supprimer le partage",
          "update_items": "Mise à jour des modules"
        },
        "restriction": {
          "paid_licence": "Licence payante"
        },
        "title": {
          "add_case_study": "Ajouter un cas d'étude",
          "add_category": "Ajouter une catégorie",
          "add_dossier": "Ajouter un dossier",
          "add_energy_consumption": "Ajouter une consommation d'énergie",
          "add_item": "Ajouter un élément",
          "add_part": "Ajouter une pièce",
          "add_phase": "Ajouter une phase",
          "add_project": "Ajouter un projet",
          "add_subassembly": "Ajouter un sous-ensemble",
          "add_transport_step": "Ajouter une étape de transport de marchandise",
          "archive_item": "Archiver",
          "bookmark": "Favori",
          "compare_db_modules": "Comparer",
          "copy_item": "Copier",
          "copy_ref_id": "Copier le ref id",
          "cut_item": "Couper",
          "define_global_template": "Ajouter aux templates d'instance",
          "delete_item": "Supprimer",
          "download_case_study_source": "Télécharger le cas d'étude source",
          "duplicate": "Dupliquer",
          "duplicate_item": "Dupliquer un élement",
          "edit_contributors": "Modifier les contributeurs",
          "edit_expiration_date": "Éditer la date d'expiration",
          "edit_icv": "Modifier l'ICV",
          "edit_item": "Modifier",
          "edit_line": "Éditer la ligne",
          "edit_manager": "Éditer le manager",
          "edit_normalization": "Modifier les normalisations",
          "edit_parameters": "Paramètres",
          "edit_ponderation": "Modifier les pondérations",
          "edit_scenarios": "Modifier les scénarios",
          "edit_tokens": "Modifier les tokens",
          "edit_workflow_and_publication_status": "Statut",
          "export": {
            "analysis": "Analyse (avancée)",
            "analysis_json": "Analyse (JSON avancé)",
            "comparison": "Comparaison",
            "design": "Design",
            "eime": "Eime",
            "inies": "Inies",
            "json_case_study": "Design JSON",
            "multi_tracking": "Design (tous les trackings)",
            "name": "Export",
            "pep_ecopassport": "PEP Ecopassport",
            "simplified_analysis": "Analyse",
            "simplified_analysis_json": "Analyse (JSON)",
            "tracking": "Design (avec tracking courant)"
          },
          "export_module": "Exporter",
          "find_in_library": "Rechercher dans la bibliothèque",
          "fix_broken": "Réparer les éléments cassés",
          "forward": "Transférer",
          "go_to_comparison": "Aller à la comparaison",
          "import_case_study": "Importer un cas d'étude",
          "import_case_study_here": "Importer un cas d'étude dans ce dossier",
          "info_item": "Informations",
          "make_available": "Mettre à disposition",
          "mark_as_favorite": "Ajouter aux favoris",
          "paste_item": "Coller",
          "paste_item_here": "Coller dans cet élément",
          "permissions": "Permissions",
          "prune_items": "Supprime les éléments dont la quantité est nulle",
          "recompute_broken": "Recalculer les éléments cassés",
          "refresh_module_impacts": "Calculer les impacts",
          "reinitialize": "Réinitialiser l'état",
          "remove_analysis_results": "Supprimer les calculs d'analyse",
          "remove_from_favorite": "Enlever des favoris",
          "remove_global_template": "Enlever des templates d'instance",
          "replace_cs_modules": "Substituer des modules",
          "replace_cs_transport_steps": "Substituer des étapes de transport",
          "replace_item": "Substituer",
          "reset_item_path": "Recalcul des item_path",
          "share": "Partager",
          "status": "Statut",
          "transform_to_module": "Transformer en module",
          "transform_to_template": "Ajouter aux modèles",
          "unarchive_item": "Désarchiver",
          "unmark_as_template": "Enlever des modèles",
          "unshare": "Supprimer le partage",
          "update_items": "Mise à jour"
        }
      },
      "check_session_timeout": {
        "disconnect": "Se déconnecter",
        "reconnect": "Se reconnecter",
        "stay_connected": "Rester connecté",
        "stay_connected_timer": "Rester connecté (%{seconds_left})",
        "too_late_message": "Votre session a été déconnectée par suite de votre inactivité.",
        "warning_timeout": "Votre session va expirer. Sans action de votre part, vous serez bientôt déconnecté."
      },
      "controllers": {
        "analysis_flow_table": {
          "track_flow": "Voir les contributions dans le design"
        },
        "current_view": {
          "view_changed": "La page que vous regardez a changé, cliquez pour la rafraichir."
        },
        "date_validator": {
          "not_a_valid_date": "doit être une date valide"
        },
        "debug/running_queries": {
          "confirm_kill": "Tuer le processus %{pid} ? Cela pourrait causer un redémarrage de la base de donnée.",
          "confirm_terminate": "Annuler la requête %{pid} ?",
          "kill": "Tue le processus postgresql",
          "terminate": "Annuler la requête"
        },
        "infinite_scroll": {
          "more_items": "Chargements des éléments supplémentaires..."
        },
        "make_cs_module": {
          "discard_unsaved": "Abandonner les modifications en cours ?"
        },
        "parameters": {
          "destroy_parameter": "Êtes-vous sûr de vouloir supprimer ce paramètre ?",
          "destroy_parameters_set": "Êtes-vous sûr de vouloir supprimer ce set de paramètres ?",
          "download": "Retrouvez votre fichier dans les téléchargements.",
          "error": "Erreur",
          "saved": "Enregistré",
          "saving": "Enregistrement..."
        },
        "step_form": {
          "discard_unsaved": "Abandonner les modifications en cours ?",
          "errors_occured": "Vérifiez le formulaire, des erreurs sont survenues à la sauvegarde."
        }
      },
      "database": {
        "publish": {
          "success": "Cet élément a bien été publié."
        }
      },
      "interface": {
        "admin": "admin",
        "analysis": "analyses",
        "comparison": "comparaison",
        "database": "base de données",
        "design": "design",
        "home": "accueil",
        "project": "projet"
      },
      "long_poll": {
        "disconnected": "Cliquez pour rafraîchir"
      },
      "ping": {
        "check_websockets": "Tester Websockets",
        "warning_missing_websockets": "<p>Afin d'améliorer les performances d’EIME, nous allons prochainement mettre en place WebSocket.</p>\n<p>Le protocole WebSocket est bloqué par votre entreprise, merci de vous rapprocher de notre service informatique ou de votre IT.</p>\n"
      }
    },
    "helpers": {
      "true_admin_only": {
        "admin": "admin",
        "visible_only_to_admins": "Visible uniquement pour les administrateurs"
      }
    },
    "make": {
      "actions": {
        "close": "Fermer",
        "extract": "Extraire dans une nouvelle fenêtre",
        "minimize": "Réduire"
      },
      "choose_parent": {
        "add_phase": "Ajouter une phase",
        "choose_parent": "Merci de choisir une phase de cycle de vie pour votre élément.",
        "create_phase": "Merci de créer des phases de cycle de vie avant d'ajouter d'autres éléments.",
        "submit": "Continuer"
      },
      "create": {
        "notice": "Notice"
      },
      "cs_case_studies": {
        "clear_template": {
          "notice": "Le cas d'étude a été retiré de la liste des modèles."
        },
        "create": {
          "notice": "Notice"
        },
        "export": {
          "notice": "Export en cours..."
        },
        "form": {
          "database": "Bases de données",
          "database_selector": "Toutes les bases de données",
          "general_information": "Paramètres",
          "incoming": "Entrante",
          "incoming_tooltip": "Pourcentage de pertes exprimé selon la quantité de pertes générées par rapport à la matière entrante, la formule suivante est utilisée :<br>Taux de pertes = Quantité de pertes / Quantité entrante.<br>Cette méthodologie est celle couramment utilisée dans l'industrie et est utilisée par défaut dans EIME",
          "informations": "Informations",
          "no_energetic_mix_marked_as_favorite": "Aucun mix énergétique en favori",
          "outgoing": "Sortante",
          "outgoing_tooltip": "Pourcentage de pertes exprimé selon la quantité de pertes générées par rapport à la matière sortante, la formule suivante est utilisée :<br>Taux de perte = Quantité de pertes / Quantité sortante.<br>Cette méthodologie est celle utilisée par défaut dans les hypothèses du programme PEP Ecopassport",
          "pep_compliant_loss_rate_change_label": "Pourcentage de pertes exprimé par rapport à la matière",
          "pep_compliant_loss_rate_change_message": "Attention, vous avez changé la méthode de calcul des quantités de perte, ce changement entraînera la modification de vos résultats",
          "popover_content": "Par défaut les pertes sont calculées par rapport à la matière entrante, soit Taux de perte = Quantité de pertes / Quantité entrante.<br>Il est possible de changer le calcul des pertes pour qu'elles soient calculées par rapport à la matière sortante, soit Taux de perte = Quantité de pertes / Quantité sortante.",
          "popover_title": "Calcul du taux de perte",
          "template_comments": "Commentaires du modèle"
        },
        "import": {
          "cs_counter_limit_exceeded": "Votre licence actuelle ne vous permet pas de créer davantage de cas d'études. Il vous reste %{file_limit} cas d'étude(s), et vous tentez d'en importer %{files_imported}.",
          "file_import_limit_exceeded": "Vous avez sélectionné plus de %{file_limit} cas d'étude.<br>\nPour garantir des performances optimales, veuillez limiter votre sélection.\n",
          "notice": "Votre import est en cours."
        },
        "indicators_set": {
          "error": "Erreur",
          "notice": "Notice"
        },
        "mark_template": {
          "notice": "Le cas d'étude a bien été marqué comme modèle."
        },
        "new": {
          "cs_counter_limit_exceeded": "Votre licence actuelle ne vous permet pas de créer davantage de cas d'études."
        },
        "update": {
          "notice": "Le cas d'étude a été modifié avec succès."
        },
        "upload_button": "Télécharger"
      },
      "cs_containers": {
        "create": {
          "notice": "Le container a été ajouté avec succès.",
          "system": "Le système est en cours de création."
        },
        "destroy": {
          "notice": "Le container a été supprimé avec succès."
        },
        "form": {
          "category_with_inheritance": "Catégorie héritée : %{inherited_category}",
          "container_type": "Type de conteneur",
          "general_information": "Paramètres",
          "no_category": "aucune",
          "title": {
            "dossier": "Dossier",
            "part": "Pièce",
            "phase": "Phase système",
            "subassembly": "Sous-ensemble"
          }
        },
        "update": {
          "notice": "Le container a été modifié avec succès."
        }
      },
      "cs_energy_consumptions": {
        "form": {
          "general_information": "Paramètres",
          "title": {
            "energy_consumption": "Consommation d'énergie"
          }
        }
      },
      "cs_flows": {
        "form": {
          "general_information": "Paramètres",
          "title": {
            "category": "Catégorie",
            "flow": "Flux"
          }
        },
        "multi_replace": {
          "success": {
            "one": "%{count} flux a été substitué avec succès.",
            "other": "%{count} flux ont été substitués avec succès."
          }
        },
        "new_multi_replace": {
          "disclaimer_units": "Si le groupe d'unité (masse, métrique...) requis par le nouveau module (ou flux) diffère de l'ancien, le nouveau se verra attribuer l'unité par défaut du nouveau groupe d'unité.",
          "disclaimer_values": "Le reste du paramètrage des anciens modules ou flux est conservé.",
          "title": "Substituer"
        }
      },
      "cs_folders": {
        "form": {
          "general_information": "Paramètres",
          "title": {
            "folder": "Dossier"
          }
        }
      },
      "cs_items": {
        "admin_recompute_broken": {
          "notice": "Recalcul des modules cassés en cours...."
        },
        "bookmark": {
          "add": "L'élément fait maintenant partie de vos favoris. Vous pouvez le retrouvez dans l'onglet «Systèmes».",
          "remove": "L'élément ne fait plus partie de vos favoris."
        },
        "create": {
          "success": "L'élément a été créé avec succès."
        },
        "forward_chown": {
          "error": "Ne peut pas transférer.",
          "success": {
            "one": "L'élément est en cours de transfert.",
            "other": "Les éléments sont en cours de transfert."
          }
        },
        "forward_copy": {
          "error": "Ne peut pas copier et transférer.",
          "success": {
            "one": "L'élément est en cours de transfert.",
            "other": "Les éléments sont en cours de transfert."
          }
        },
        "move": {
          "error": {
            "phase_moves_only_in_case_study": "A phase can be only move in a case study."
          }
        },
        "multi_destroy": {
          "success": {
            "one": "L'élément est en cours de suppression.",
            "other": "Les éléments sont en cours de suppression."
          }
        },
        "multi_destroy_message": {
          "default": "Voulez-vous mettre à la corbeille %{num_items} item(s) ?",
          "error_unlink_energetic_mix": "Impossible de mettre à la corbeille un module de mix énergétique sans son module parent.",
          "with_linked": "Voulez-vous mettre à la corbeille %{num_items} item(s) dont %{num_linked} module(s) lié(s) ?"
        },
        "multi_fix_broken": {
          "notice": "Réparation des modules en cours...."
        },
        "multi_update": {
          "success": "Les éléments ont été modifiés avec succès."
        },
        "multi_update_version": {
          "notice": "Mise à jour des modules en cours..."
        },
        "paste": {
          "error": {
            "cannot_paste_inside_itself": "Il est impossible de coller un élément à l'intérieur de lui-même.",
            "cannot_paste_trashed": "Un ou plusieurs éléments de votre presse-papier ont été mis à la corbeille. Restaurez ces éléments si vous souhaitez les coller.",
            "case_study_restrictions": "Un cas d'étude ne peut pas être placé à l'intérieur d'un autre cas d'étude.",
            "containers_restrictions": "Un conteneur (dossier, sous-ensemble, pièce) ne peut être placé qu'à l'intérieur d'une phase ou d'un autre conteneur.",
            "folder_restrictions": "Un sous dossier projet ne peut pas être placé à l'intérieur d'un cas d'étude.",
            "leafs_restrictions": "Les flux, les modules, les transports et les consommations d'énergies ne peuvent être placés qu'à l'intérieur d'une phase ou d'un conteneur.",
            "module_d_restrictions": "Un cas d'étude ne peut contenir qu'une seule phase de type module D.",
            "no_items": "Aucun élément n'est à coller.",
            "one": "L'élément ne peut pas être collé.",
            "other": "Les éléments ne peuvent pas être collés.",
            "phase_restrictions_duplicate": "Une phase ne peut être collée qu'à la racine d'un cas d'étude, dans une autre phase ou dans un conteneur.",
            "phase_restrictions_move": "Une phase ne peut être déplacée qu'à la racine d'un cas d'étude."
          }
        },
        "reinitialize": {
          "success": {
            "one": "L'élément a été réinitialisé avec succès.",
            "other": "Les éléments ont été réinitialisés avec succès."
          }
        },
        "reject": "Vous ne pouver pas effectuer d'action ou parcourir un élément qui n'est pas valide.",
        "reject_insert": "Vous ne pouvez pas insérer cet élément à la racine d'un cas d'étude.",
        "share": {
          "add": "L'élément a bien été partagé. Vous pouvez le retrouvez dans l'onglet «Systèmes».",
          "remove": "L'élément n'est plus partagé."
        },
        "track": {
          "notice": "Le tracking a été modifié avec succès."
        },
        "update": {
          "success": "L'élément a bien été mis à jour."
        }
      },
      "cs_module_form": {
        "common_fields_component": {
          "popover_secondary_quantity_formula": "Impact du module = LCI * valeur de la 1ère quantité * (valeur de la 2ème quantité / valeur de référence de la 2ème quantité)"
        },
        "preload_scenario_component": {
          "creation": "Création des modules",
          "energetic_mix_shortcut": "Raccourci - remplissage automatique des mix énergétique"
        }
      },
      "cs_modules": {
        "form": {
          "add": "Ajouter",
          "add_module": "+&nbsp;&nbsp;Module",
          "add_scenario": "+&nbsp;&nbsp;Scénario",
          "advanced_parameters": "Paramètres avancés",
          "broken": "Module cassé",
          "creating": "En cours de création",
          "db_module_not_found": "Module introuvable.",
          "deprecated_soon": "Bientôt obsolète",
          "deprecated_soon_popover": "Cette donnée sera rendue obsolète pour les projets avec une date antérieure au %{date}. Une donnée de remplacement plus adaptée est normalement disponible dans la base de données.",
          "documentation": "Page de documentation",
          "end_of_life": "Fin de vie",
          "energetic_mix": "Mix énergétique",
          "favorite_mixes": "Favoris",
          "forbidden_scenario": "Ce scénario est incompatible avec la date de votre projet ou avec votre licence.",
          "general_information": "Informations générales",
          "info_ecobilan_id": "Ecobilan id.",
          "info_module_uuid": "Module UUID",
          "info_version": "Version (date de disponibilité)",
          "information": "Informations",
          "linked_process": "Processus",
          "loss_rate_percentage_variable": "Pp",
          "loss_rate_variable_math": "<msub><mi>P</mi><mi>p</mi></msub>",
          "main_module": "Module principal",
          "module_d": "Module D",
          "non_favorite_mixes": "Autres",
          "quantity_including_losses": "Quantité avec les pertes",
          "quantity_losses": "Quantité de pertes : ",
          "quantity_variable": "Q",
          "quantity_variable_math": "<mi>Q</mi>",
          "renewable_percentage_hint": "Le pourcentage renouvelable exprime le pourcentage de la masse du produit provenant de sources renouvelables, telles que la sylviculture durable.",
          "second_parameters_html": "Ce module a été modélisé pour être représentatif entre <b>%{min}</b> et <b>%{max}</b> %{unit}.",
          "second_parameters_name_html": "Ce module a été modélisé avec le critère suivant <b>%{name}</b> comme second paramètre.",
          "second_quantity_variable": "Q2",
          "select_a_scenario": "Choisir un scénario",
          "submit": "Enregistrer et fermer",
          "update": "Enregistrer",
          "warning_partly_terminated": "Veuillez noter que cette donnée n'est que partielle.\nMerci de vous référer à la fiche de documentation et suivre les instructions situées dans la partie « Conseils utile pour le set de données » afin de compléter cette donnée.\nSi cette donnée propose des scénarios de processus, vous devez les ajouter pour finir la donnée.\n"
        },
        "show": {
          "read_only_flag": "Lecture seule"
        },
        "update": {
          "notice": "Le module est mis à jour"
        }
      },
      "cs_phases": {
        "form": {
          "general_information": "Paramètres",
          "title": {
            "phase": "Phase"
          }
        }
      },
      "cs_projects": {
        "create": {
          "success": "Le projet a été créé avec succès."
        },
        "form": {
          "general_information": "Paramètres",
          "title": {
            "project": "Projet"
          }
        },
        "update": {
          "success": "Le projet a été modifié avec succès."
        }
      },
      "cs_systems": {
        "create": {
          "system": "Système"
        },
        "form": {
          "create": "Ajouter un système",
          "title": {
            "system": "System"
          }
        },
        "new": {
          "advanced_insertion": "Ajout avancé",
          "advanced_insertion_description": "Choisir les emplacements de destination et les éléments du système que vous souhaitez ajouter à votre cas d'étude.",
          "create": "Ajouter un système",
          "expected_lifetime": "Durée de vie",
          "functional_unit_ratio": "Ratio de l'unité fonctionnelle",
          "general_information": "Paramètres",
          "in": "dans",
          "information": "Information",
          "insert_in_phase": "dans la phase %{phase_name}",
          "insert_phase": "Insérer la ou les phase(s)",
          "insert_phases_methods": "Méthodes d'insertion par phase",
          "not_allowed": "Un sytème ne peut pas être inséré à la racine d'un cas d'étude.",
          "quick_insertion": "Ajout rapide",
          "quick_insertion_description": "Ajouter le système entier dans votre vue courante",
          "real_weight": "Poids réel",
          "title": "Ajouter un système",
          "warning": "Le ratio de l'unité fonctionnelle est à titre indicatif et ne sera pas pris en compte pour le cas d'étude courant."
        }
      },
      "cs_transport_steps": {
        "edit": {
          "title": "Éditer « %{name} »"
        },
        "form": {
          "average_load_percentage_information": "La formule pour les étapes de transport a été définie pour un pourcentage de chargement supérieur à 50%.",
          "general_information": "Paramètres",
          "header": "Étape de transport de marchandise"
        },
        "new": {
          "title": "Ajouter une étape de transport de marchandise"
        }
      },
      "db_flows": {
        "form": {
          "general_information": "Paramètres"
        },
        "publish": {
          "success": "Le flux a bien été publié."
        }
      },
      "db_module_from_cs_case_studies": {
        "new": {
          "back": "Retour",
          "force_type_of_dataset": "Forcer le type de données (laisser vide par défaut)"
        },
        "new_preset": {
          "recommendation": "Vous êtes sur le point de transformer un cas d'étude en donnée d'ICV.\nVeuillez vérifier que votre cas d'étude est à jour des dernières versions des données et qu'il ne contient pas d'élément cassé.\n"
        }
      },
      "db_module_scenarios": {
        "breadcrumb": {
          "title": "Scénarios pour [%{ecobilan}]"
        },
        "copy_scenarios": {
          "all_linked_modules_types": "Tous",
          "any_version": "Disponibles pour toutes les versions du module %{ecobilan}",
          "provider": "Scénarios à copier depuis...",
          "quantity_formula": "Nouvelle formule de quantité",
          "second_quantity_formula": "Nouvelle formule de seconde quantité (si nécessaire)",
          "select_scenarios_type": "Sélection des scénarios",
          "submit": "Démarrer la copie",
          "subtitle": "Copier des scénarios",
          "title": "Scénarios pour %{name}",
          "update_quantity_formula": "Mettre à jour la formule de quantité"
        },
        "edit": {
          "title": "Scénarios pour %{name}"
        },
        "form": {
          "new_module": "Ajouter un module"
        },
        "form_for_scenario_linked_module_component": {
          "could_not_find_module_in_database": "Le module n'a pas pu être trouvé dans la base de données.",
          "destroy_confirm": "Êtes-vous sûrs de vouloir supprimer ce module ?",
          "popover_content": "Vous devez indiquer ici une formule comprenant au moins une des variable suivantes : <br><br> <strong>· containers_quantity<br>· quantity_with_losses<br>· quantity_without_losses<br>· quantity_losses<br>· second_quantity</strong><br><br>Exemple<br>quantity_with_losses * 3.14",
          "popover_title": "Formules",
          "remove_module": "Supprimer"
        },
        "index": {
          "add_description": "Création d'un nouveau scénario pour votre module.",
          "add_title": "Ajout",
          "copy_description": "Ajouter des scénarios à partir d'un autre module.",
          "copy_title": "Copie",
          "delete_description": "Suppression rapide de plusieurs scénarios, filtrables par type.",
          "delete_title": "Suppression",
          "see_scenarios_list": "Pour consulter, modifier ou supprimer un scénario existant, utilisez la liste déroulante à votre droite.",
          "subtitle": "Actions possibles",
          "title": "Scénarios pour %{name}"
        },
        "multi_destroy": {
          "confirm": "Êtes-vous sûrs de vouloir supprimer les scénarios sélectionnés ? Cette action  est irréversible.",
          "delete_scenarios": "Veuillez sélectionner un ou plusieurs types de scénarios à supprimer. Les scénarios sélectionnés sont ceux de la version en cours, ainsi que ceux disponibles pour toutes les versions du module.",
          "submit": "Supprimer",
          "subtitle": "Suppression rapide",
          "title": "Scénarios pour %{name}"
        },
        "new": {
          "subtitle": "Ajouter un scénario",
          "title": "Scénarios pour %{name}"
        },
        "scenarios_list": {
          "all": "Tous",
          "for_any_version": "S'applique à toutes les versions du module",
          "for_version": "S'applique à la version %{version}",
          "no_scenario": "Aucun scénario existant.",
          "scenarios_count": "Scénarios existants (%{count})",
          "search": "Rechercher",
          "search_by_name": "Chercher par nom"
        },
        "show": {
          "add": "Ajouter un scénario",
          "destroy": "Supprimer",
          "destroy_confirm": "Êtes-vous sûrs de vouloir supprimer ce scénario ?",
          "edit": "Modifier",
          "title": "Scénarios pour %{name}"
        }
      },
      "db_modules": {
        "check": {
          "go_to_form": "Retourner au formulaire"
        },
        "check_rules": {
          "check_failed": "Certaines vérifications ont échouées.",
          "check_run": "Les vérifications suivantes ont été passées pour votre module de type",
          "check_successful": "Toutes les vérifications sont passées.",
          "mandatory": "Règles obligatoires",
          "optional": "Bonnes pratiques",
          "title": "Vérification de la donnée"
        },
        "edit_available_date": {
          "go_to_form": "Retourner au formulaire",
          "ignore_and_make_available": "Ignorer et mettre à disposition",
          "invalid_db_module": "Certaines informations sont manquantes.",
          "make_available": "Mettre à disposition",
          "missing_information": "Vous devez encore renseigner ou rectifier les informations suivantes avant de pouvoir mettre à disposition votre module :"
        },
        "edit_deprecated_date": {
          "add_substitution_dataset": "Ajouter une nouvelle donnée de substitution",
          "confirm": "Confirmez-vous l'obsolescence ? Cette action est irréversible.",
          "delete_substitution_dataset": "Supprimer",
          "deprecate_all_versions": "Déprécier toutes les versions de la donnée",
          "deprecate_all_versions_subtitle": "Conseil d'utilisation: si vous choisissez de déprécier toutes les versions de votre donnée, vous pouvez définir des données de substitution pour conseiller les utilisateurs dans leur choix de remplacement.",
          "scenarios_available": {
            "one": "%{count} scénario disponible",
            "other": "%{count} scénarios disponibles",
            "zero": "Aucun scénario"
          },
          "submit": "Valider",
          "title": "Gestion de l'obsolescence"
        },
        "form": {
          "generic_publication": "Requis pour la publication",
          "not_component_publication": "Requis pour la publication, sauf pour un composant",
          "not_uap_publication": "Requis pour la publication, sauf pour un procédé sans matière"
        },
        "form_for_available_date_component": {
          "confirm": "Confirmez-vous la disponibilité de cet élément ? Cette action est irréversible.",
          "irreversible": "publication définitive et irréversible",
          "please_pick_date": "Les exigences minimales définies dans EIME sont atteintes (note : ce contrôle ne remplace pas une vérification).\nVotre donnée peut être rendue disponible. Veuillez choisir une date de mise à disposition.\n",
          "submit": "Mettre à disposition",
          "title": "Mettre à disposition"
        },
        "form_for_multi_available_date_component": {
          "confirm": "Confirmez-vous la disponibilité de ces éléments ? Cette action est irréversible.",
          "has_errors": "%{count_errors} module(s) sur %{count} ne peuvent pas être mis à disposition.\nVeuillez vérifier les informations de ces modules individuellement :\n",
          "irreversible": "publication définitive et irréversible",
          "please_pick_date": "%{count} modules vont être mis à disposition :",
          "submit": "Mettre à disposition",
          "title": "Mise à disposition de plusieurs modules"
        },
        "form_for_workflow_and_publication_status_component": {
          "help_content": "<strong>Version de travail:</strong><p>La donnée est en phase préliminaire de développement.</p>\n<strong>Version finale pour revue interne:</strong><p>La donnée est terminée et prête pour une revue interne.</p>\n<strong>Version finale pour revue externe:</strong><p>La donnée est prête pour une revue externe (après une éventuelle revue interne et une correction si nécessaire).</p>\n<strong>Donnée finalisée; non publiée:</strong><p>La donnée est finalisée (avec ou sans révision interne et/ou externe et correction si nécessaire), mais elle n'est pas encore publiée.</p>\n<strong>En cours de revue:</strong><p>La donnée est en cours de révision et sa publication est prévue.</p>\n<strong>Donnée finalisée; entièrement publiée:</strong><p>La donnée est finalisée (avec ou sans révision interne et/ou externe et correction si nécessaire), et elle est entièrement publiée.</p>\n",
          "help_title": "Statuts",
          "irreversible": "publication définitive et irréversible",
          "keep": "Conserver la version actuelle (%{ext_version})",
          "major_upgrade": "Mise à jour majeure (%{ext_version})",
          "manual": "Choisir la version manuellement",
          "minor_upgrade": "Mise à jour mineure (%{ext_version})",
          "submit": "Soumettre",
          "title": "Éditer le statut",
          "versionning_options": "Mettre à jour la version (uniquement en cas de publication définitive)"
        },
        "multi_update_available_date": {
          "success": "Vos modules ont bien été mis à disposition."
        },
        "refresh_impacts": {
          "success": "Les impacts du module ont été mis à jour."
        },
        "update_available_date": {
          "success": "Le module a bien été mis à disposition."
        }
      },
      "destroy": {
        "notice": "Notice"
      },
      "error": {
        "title": "Erreur"
      },
      "indicators": {
        "publish": {
          "success": "L'indicateur a bien été publié. Un rafraîchissement des impacts est en cours. Cette opération peut durer plusieurs minutes."
        },
        "toggle_archive": {
          "success": "L'indicateur a bien été mis à jour."
        }
      },
      "indicators_sets": {
        "form": {
          "create": "Créer",
          "edit": "Modifier un set d'indicateurs",
          "new": "Nouveau set d'indicateurs",
          "published_on": "publié le %{available_date}",
          "update": "Mettre à jour"
        },
        "publish": {
          "success": "Le set d'indicateurs a bien été publié."
        },
        "toggle_archive": {
          "success": "Le set d'indicateurs a bien été mis à jour."
        }
      },
      "make_forms": {
        "already_opened": "Impossible d'ouvrir un second formulaire lorsqu'un formulaire est déjà ouvert."
      },
      "modules": {
        "information": "Informations",
        "new": "Ajouter un %{model}"
      },
      "multi_replace": {
        "replacement_report_component": {
          "error": {
            "one": "Un élément n'a pas été substitué:",
            "other": "Ces %{count} éléments n'ont pas été substitués:"
          },
          "no_items_found": "Aucune donnée correspondant à votre demande n'a été trouvée. Aucune substitution n'a été effectuée.",
          "success": {
            "one": "Un élément a bien été substitué:",
            "other": "%{count} éléments ont bien été substitués:"
          },
          "title": "Vous avez demandé à remplacer <strong>%{old_db_module_name}</strong> par <strong>%{new_db_module_name}</strong>."
        }
      },
      "normalizations": {
        "form": {
          "back": "Retour",
          "delete": "Supprimer",
          "edit": "Modifier",
          "factors": "Facteurs de normalisation",
          "new": "Nouvelle normalisation",
          "page_title": "Normalisation pour %{indicators_set}"
        },
        "index": {
          "page_title": "Normalisation pour %{indicators_set}"
        }
      },
      "panel_component": {
        "create": "Créer",
        "update": "Mettre à jour"
      },
      "partials": {
        "panel": {
          "create": "Créer",
          "update": "Mettre à jour"
        }
      },
      "permissions_component": {
        "change": "Modifier",
        "non_recursive_permissions": {
          "no_access": "Accès non autorisé",
          "owner": "Propriétaire",
          "readable": "Accès en lecture à certains sous-éléments",
          "undefined": "Aucune permission",
          "writable": "Accès en création à certains sous-éléments"
        },
        "reason": {
          "admin": "automatique (administrateur)",
          "inherited": "hérité du dossier parent",
          "manager": "automatique (responsable)",
          "manual": "défini par le propriétaire",
          "no_perm": "non défini",
          "owner": "automatique (propriétaire)",
          "owner_manager": "automatique (responsable)"
        },
        "recursive_permissions": {
          "no_access": "Accès non autorisé",
          "readable": "Accès en lecture à tous les sous-éléments",
          "undefined": "Aucune permission",
          "writable": "Accès en création à tous les sous-éléments"
        },
        "set_non_recursive_permissions": {
          "no_access": "Interdire l'accès",
          "readable": "Accès en lecture aux sous-éléments autorisés",
          "writable": "Accès en création aux sous-éléments autorisés"
        },
        "set_recursive_permissions": {
          "no_access": "Interdire l'accès",
          "readable": "Accès en lecture à tous les sous-éléments",
          "writable": "Accès en création à tous les sous-éléments"
        },
        "title_permissions": {
          "no_access": "Accès non autorisé",
          "readable": "Accès en lecture",
          "writable": "Accès en création"
        },
        "unset_permissions": {
          "no_access": "Supprimer l'interdiction d'accès",
          "readable": "Supprimer l'accès en lecture",
          "writable": "Supprimer l'accès en création"
        }
      },
      "ponderations": {
        "form": {
          "back": "Retour",
          "delete": "Supprimer",
          "edit": "Modifier",
          "factors": "Facteurs de pondération",
          "new": "Nouvelle pondération",
          "page_title": "Pondération pour %{indicators_set}"
        },
        "index": {
          "page_title": "Pondération pour %{indicators_set}"
        }
      },
      "refresh": {
        "index": {
          "refresh_instances": "Rafraîchir les instances"
        },
        "show_instance": {
          "instance": "Instance %{name}",
          "last_refresh": "Dernier rafraîchissement : %{date}",
          "last_refresh_error": "Dernier rafraîchissement en échec : %{date}",
          "last_update": "version de la base de données : %{date}",
          "number_of_flows": "%{count} flux",
          "number_of_modules": "%{count} modules",
          "refresh": "Rafraîchir",
          "refresh_confirm": "Le rafraîchissement est une opération longue et la base de données semble à jour, voulez-vous tout de même continuer ?",
          "refresh_progress": "Rafraîchissement %{step_num}/%{step_max} : %{step_name}",
          "refresh_requested": "Rafraîchissement en attente",
          "refresh_step": {
            "compute_flow_impacts": "Calcul des impacts des flux",
            "compute_module_impacts": "Calcul des impacts des modules",
            "copy_immutable_impacts": "Copie des impacts immuables",
            "copy_mutable_impacts": "Copie des impacts calculés",
            "refresh_database": "Copie de la base de données %{table_name}",
            "remove_obsolete_impacts": "Nettoyage des impacts obsolètes"
          },
          "up_to_date": "Base de donnée à jour"
        }
      },
      "replace": {
        "cs_modules": {
          "form_component": {
            "choose_energetic_mix": "Mix énergétique",
            "quantity_action": {
              "keep": "Conserver les valeurs actuelles",
              "reset": "Utiliser la seconde quantité par défaut de la nouvelle donnée",
              "use_ratio": "Utiliser un ratio"
            },
            "recommended": "Donnée recommandée.",
            "replace_all_is_unavailable": "La substitution globale (remplacement de tous les mêmes éléments dans le cas d'étude) n'est pas disponible\npour cet élément car la liaison avec sa donnée d'origine a été rompue (module cassé).\n",
            "replace_in_ref_id": {
              "add_replacement_id": "Ajouter un emplacement",
              "choose_cs_phase_or_container": "Tous les mêmes modules dans un ou plusieurs emplacements à sélectionner",
              "cs_case_study": "Tous les mêmes modules dans le cas d'étude",
              "none": "Uniquement ce module"
            },
            "replace_in_ref_id_label": "Substituer",
            "submit": "Substituer",
            "suggested_substitutions": "Suggestions de substitution",
            "tooltip_formula": "Vous pouvez indiquer ici une formule avec les quatre opérations courantes (+, -, *, /) ainsi que des fonctions mathématiques. Pour certaines formules, des variables sont également disponibles."
          },
          "help": {
            "energetic_mix": "Les mix énergétiques sont indissociables de leur module d'origine. Si votre nouveau module est configurable, vous devez lui réassigner un mix énérgétique.",
            "label_energetic_mix": "Mix énergétique",
            "label_substitutions": "Suggestions",
            "label_units": "Unités",
            "net_calorific_value": "Si existant, la valeur du pouvoir calorifique inférieur est automatiquement remplacée par celle de la nouvelle donnée.",
            "quantity": "La quantité de votre module est conservée par défaut. Vous pouvez aussi appliquer un ratio, par exemple si le groupe d'unité de la nouvelle donnée diffère de l'ancienne. Le ratio sera conservé en conservant votre formule d'origine: '(formule_originelle) * (ratio)'.",
            "renewable_percentage": "Si existant, la valeur du pourcentage de matière renouvelable est automatiquement remplacée par celle de la nouvelle donnée.",
            "second_quantity": "Comme la quantité principale, vous pouvez conserver la valeur ou appliquer un ratio. Vous pouvez également choisir d'appliquer la valeur par défaut de la nouvelle donnée. Dans ce cas, elle écrasera votre ancienne valeur.",
            "substitutions": "Lorsque cela est possible, nous vous proposons des données de remplacement pour les données obsolètes.\nPrenez garde à bien prendre en compte les points de mises en garde notés en commentaire.\n",
            "units": "Si les groupes d'unité (masse, métrique...) requis par la nouvelle donnée diffèrent de l'ancien, le module se verra attribuer les unités par défaut des nouveaux groupes d'unité."
          },
          "replace": {
            "title": "Substituer"
          }
        },
        "cs_transport_steps": {
          "form_component": {
            "no_ratio_for_transport_steps": "Attention, veuillez noter que l'application automatique de ratios n'est pas possible pour les étapes de transport.",
            "origin_dataset": "Donnée d'origine",
            "recommended": "Donnée recommandée.",
            "replace_all_is_unavailable": "La substitution globale (remplacement de tous les mêmes éléments dans le cas d'étude) n'est pas disponible\npour ce transport car la liaison avec sa donnée d'origine a été rompue (transport cassé).\n",
            "replace_in_ref_id": {
              "add_replacement_id": "Ajouter un emplacement",
              "choose_cs_phase_or_container": "Tous les mêmes transports dans un ou plusieurs emplacements à sélectionner",
              "cs_case_study": "Tous les mêmes transports dans le cas d'étude",
              "none": "Uniquement ce transport"
            },
            "replace_in_ref_id_label": "Substituer",
            "replacement_dataset": "Donnée de remplacement",
            "submit": "Substituer",
            "suggested_substitutions": "Suggestions de substitution"
          },
          "help": {
            "label_load_rates": "Pourcentages de chargement moyen et de retour à vide",
            "label_other_attributes": "Masse totale transportée, distance et taux",
            "label_substitutions": "Suggestions",
            "load_rates": "Vous pouvez renseigner ces champs si vous passez d'un type de transport aérien, maritime ou ferroviaire à un transport routier.\nVous pouvez aussi laisser les valeurs par défaut.\n",
            "other_attributes": "Lors de la substitution, ces paramètres seront conservés à l'identique.",
            "substitutions": "Lorsque cela est possible, nous vous proposons des données de remplacement pour les données obsolètes.\nPrenez garde à bien prendre en compte les points de mises en garde notés en commentaire.\n"
          },
          "replace": {
            "title": "Substituer"
          }
        }
      },
      "statuses": {
        "create": {
          "success": "Le status a été modifié avec succès."
        }
      },
      "templates_collection": {
        "create": {
          "notice": "Le cas d'étude a été défini comme modèle global."
        },
        "destroy": {
          "notice": "Le cas d'étude a été retiré des modèles globaux."
        }
      },
      "update": {
        "notice": "Notice"
      },
      "users_cs_item": {
        "update": "Mise à jour"
      },
      "users_cs_items": {
        "create": {
          "notice": "Notice"
        },
        "permission_remove": "Supprimer la permission",
        "update_all": {
          "notice": "Les permissions ont été mises à jour avec succès.",
          "protection_error": "Il est impossible de redéfinir les permissions pour le propriétaire du projet %{name}."
        }
      }
    },
    "no_results": "Pas de résultat.",
    "ok": "Valider",
    "project": {
      "actions": {
        "archive": {
          "name": "Archiver / Désarchiver",
          "shortcut": "Maj + A"
        },
        "bookmark": {
          "name": "Favori",
          "shortcut": "Shortcut"
        },
        "copy_item": {
          "name": "Copier",
          "shortcut": "Maj + C"
        },
        "cut_item": {
          "name": "Couper",
          "shortcut": "Maj + X"
        },
        "delete_item": {
          "name": "Supprimer",
          "shortcut": "Del"
        },
        "duplicate": {
          "name": "Dupliquer",
          "shortcut": "Maj + D"
        },
        "edit_item": {
          "name": "Editer",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "Renommer",
          "shortcut": "E"
        },
        "export": {
          "name": "Exporter",
          "shortcut": "Shortcut"
        },
        "export_analysis": {
          "name": "Exporter l'analyse",
          "shortcut": "Shortcut"
        },
        "export_design": {
          "name": "Exporter le design",
          "shortcut": "Shortcut"
        },
        "export_eime": {
          "name": "Exporter au format EIME",
          "shortcut": "Shortcut"
        },
        "export_inies": {
          "name": "Exporter au format INIES",
          "shortcut": "Shortcut"
        },
        "export_pep_ecopassport": {
          "name": "Exporter au format PEP Ecopassport",
          "shortcut": "Shortcut"
        },
        "go_to_analysis": {
          "name": "Aller à l'analyse",
          "shortcut": "A"
        },
        "go_to_comparison": {
          "name": "Aller à la comparaison",
          "shortcut": "Shortcut"
        },
        "go_to_design": {
          "name": "Aller au design",
          "shortcut": "D"
        },
        "import": {
          "name": "Importer un cas d'étude",
          "shortcut": "Shortcut"
        },
        "paste_item": {
          "name": "Coller",
          "shortcut": "Maj + P"
        },
        "remove_global_template": {
          "name": "Enlever des templates d'instance"
        },
        "share": {
          "name": "Partager",
          "shortcut": "Shortcut"
        },
        "status": {
          "name": "Status",
          "shortcut": "Shortcut"
        },
        "transform_to_template": {
          "name": "Ajouter aux modèles",
          "shortcut": "Maj + T"
        },
        "unarchive": {
          "name": "Désarchiver / Archiver",
          "shortcut": "Maj + A"
        },
        "unmark_as_template": {
          "name": "Enlever des modèles"
        }
      },
      "add": {
        "case_study": {
          "name": "Nouveau cas d'étude",
          "shortcut": "Maj + C"
        },
        "folder": {
          "name": "Nouveau dossier",
          "shortcut": "Maj + D"
        },
        "project": {
          "name": "Nouveau projet",
          "shortcut": "Maj + P"
        }
      },
      "cs_case_studies": {
        "bookmark": {
          "add": "Ce cas d'étude a été mis en favoris. Vous pouvez le trouver dans le menu \"Système\"",
          "remove": "Ce cas d'étude a été supprimé des favoris."
        },
        "create": {
          "notice": "Le cas d'étude est en cours de création."
        },
        "destroy": {
          "notice": "Le cas d'étude a été supprimé avec succès."
        },
        "indicators_set": {
          "error": "Le set d'indicateurs n'a pas pu être changé.",
          "notice": "Le set d'indicateurs à été changé."
        },
        "share": {
          "add": "Le cas d'étude a été partagé avec succès. Vous pouvez le trouver dans le menu \"Système\"",
          "remove": "Le partage de cas a été annulé."
        },
        "update": {
          "notice": "Le cas d'étude a été modifié avec succès."
        }
      },
      "cs_case_study_statuses": {
        "back": "Fermer",
        "create": {
          "success": "Le changement de statut du cas d'étude a bien été pris en compte."
        },
        "submit": "Valider"
      },
      "cs_projects": {
        "reject_edit": "Vous n'êtes pas autorisé à modifier ce projet",
        "reject_insert": "Vous n'êtes pas autorisé à créer de projet"
      },
      "delete_confirm": "Êtes-vous sûr de vouloir supprimer ce(s) élément(s) ?",
      "delete_denied": "Impossible de supprimer des projets qui ne sont pas vides.",
      "details": {
        "analysis": "Analyse",
        "creation": "Création",
        "creation_type": "Type de création",
        "database": "Base de données",
        "db_module_released_at": "Version",
        "db_module_released_at_unset": "Dernière par défaut",
        "default_template": "%{name} (par défaut)",
        "functional_unit": "Unité fonctionnelle",
        "inies": "Informations INIES",
        "less_info": "Moins d'informations",
        "more_info": "Plus d'informations",
        "notes": "Notes",
        "permissions": "Permissions",
        "title": "Détails",
        "unset": "Non défini"
      },
      "display": {
        "visible_columns": "Colonnes visibles"
      },
      "filter_type": {
        "ecobilan_all": "Ecobilan dans tous les projets",
        "ecobilan_current": "Ecobilan dans le projet ou dossier courant",
        "name_all": "Nom dans tous les projets",
        "name_current": "Nom dans le projet ou dossier courant"
      },
      "filter_user": {
        "all": "Tous",
        "default": "Par défaut",
        "label": "Filtrer par utilisateur :"
      },
      "global": {
        "import": {
          "name": "Importer",
          "shortcut": "Shortcut"
        }
      },
      "index": {
        "title": "Mes projets"
      },
      "items_filter_component": {
        "filter_by": "Filtrer par",
        "search": "Recherche",
        "update": "Mettre à jour"
      },
      "library": {
        "clear": "Nettoyer",
        "search": "Rechercher"
      },
      "overview": {
        "badges": {
          "instance_template": "template d'instance"
        },
        "columns": {
          "badges": {
            "db_locked": "La base de donnée est verrouillée à une date fixe",
            "read_only": {
              "description": "Lecture seule : vous n'êtes pas le propriétaire",
              "text": "lecture seule"
            },
            "templated": "<p><strong>Modèle</strong></p>\n<p>Ce cas d'étude peut être utilisé comme modèle pour d'autres cas d'études. Il doit ête ajouté à un projet pour pouvoir être utilisé pour les nouveaux cas d'études du projet.</p>\n"
          },
          "bookmark_icon": "Favori",
          "buttons": "Actions",
          "comments": "Commentaires",
          "created_at": "Création",
          "db_module_released_at": "Date des modules",
          "ico": "Icône",
          "id": "Id",
          "name": "Nom",
          "path": "Chemin",
          "rank": "Rang",
          "share_icon": "Partage",
          "state": "Etat",
          "status": "Statut",
          "team": "Equipe",
          "updated_at": "Mise à jour",
          "user": "Propriétaire"
        }
      },
      "search": {
        "clear": "Effacer",
        "placeholder": "Rechercher",
        "search_elements": "Rechercher",
        "submit": "Rechercher",
        "tooltip": ""
      },
      "virtual_root": "Mes projets",
      "virtual_root_archived": "Mes projets archivés"
    },
    "ui": {
      "flying_notifications_component": {
        "dismiss": "Fermer"
      },
      "interactive_breadcrumb": {
        "breadcrumb": {
          "clear": "Effacer"
        }
      },
      "interactive_breadcrumb_category_component": {
        "clear": "Effacer"
      },
      "toggle_panel_bar_component": {
        "maximize": "Ré-ouvrir le panneau",
        "minimize": "Minimiser le panneau"
      }
    }
  },
  "zh": {
    "admin": {
      "actions": {
        "add": {
          "company": "公司",
          "instance": "实例",
          "user": "用户"
        },
        "archive": {
          "name": "Archive"
        },
        "delete_item": {
          "name": "删除",
          "shortcut": "Del"
        },
        "duplicate": {
          "name": "复制",
          "shortcut": "Maj + D"
        },
        "edit_expiration_date": {
          "name": "编辑有效期",
          "shortcut": "Maj + X"
        },
        "edit_item": {
          "name": "编辑",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "重新命名"
        },
        "edit_line_admin": {
          "name": "编辑线",
          "shortcut": "E"
        },
        "edit_manager": {
          "name": "编辑管理器",
          "shortcut": "M"
        },
        "edit_managers": "编辑管理人员",
        "reactiv_license": {
          "name": "重新激活许可证"
        },
        "unarchive": {
          "name": "Unarchive"
        }
      },
      "add": {
        "company": {
          "name": "添加公司",
          "shortcut": "快捷方式"
        },
        "instance": {
          "name": "添加实例",
          "shortcut": "快捷方式"
        },
        "user": {
          "name": "添加用户",
          "shortcut": "快捷方式"
        }
      },
      "communication": {
        "create": {
          "success_message": "通信已成功创建。"
        },
        "destroy": {
          "failure_message": "通信无法删除。",
          "success_message": "交流 %{name} 被成功摧毁。"
        },
        "update": {
          "success_message": "通信已成功更新。"
        }
      },
      "communications": {
        "partials": {
          "toolbar": {
            "refresh": "Communications",
            "refresh_confirm": "Refresh the following tables: %{tables}",
            "refresh_title": "Refresh communications"
          }
        }
      },
      "company": {
        "create": {
          "success_message": "成功创建公司"
        },
        "destroy": {
          "failure_message": "公司无法删除",
          "success_message": "公司 %{name} 已成功销毁"
        },
        "update": {
          "success_message": "公司已成功更新"
        }
      },
      "delete_confirm": "您确定要删除这个/这些项目吗？",
      "details": {
        "title": "Details"
      },
      "instances": {
        "archive_instance": "Archived instances",
        "create": {
          "success_message": "实例已成功创建"
        },
        "destroy": {
          "failure_message": "无法删除实例",
          "success_message": "成功销毁了 %{name} 实例"
        },
        "root_instance": "Instances",
        "toggle_archive": {
          "success_message": "The instance has been updated."
        },
        "update": {
          "success_message": "实例已成功更新"
        }
      },
      "overview": {
        "columns": {
          "communication": {
            "name": "通讯名称"
          }
        }
      },
      "partials": {
        "toolbar": {
          "refresh": "Users",
          "refresh_confirm": "Refresh the following tables: %{tables}",
          "refresh_title": "Refresh users"
        }
      },
      "refresh": {
        "refresh_success": "刷新数据库"
      },
      "refresh_users": {
        "refresh_success": "刷新数据库"
      },
      "toolbar": {
        "search": "搜索"
      },
      "user": {
        "create": {
          "success_message": "用户创建成功"
        },
        "default_language": {
          "english": "英语",
          "french": "法语"
        },
        "destroy": {
          "failure_message": "无法删除用户",
          "success_message": "User successfully destroyed."
        },
        "update": {
          "success_message": "用户已成功更新"
        }
      },
      "users": {
        "edit_expiration_date": {
          "title": "Edit expiration dates"
        },
        "edit_manager": {
          "title": "Edit manager(s)"
        },
        "partials": {
          "details_item": {
            "empty_partners": "No team."
          }
        },
        "update_expiration_date": {
          "success": "Update successful."
        },
        "update_manager": {
          "success": "Update successful."
        }
      }
    },
    "analysis": {
      "abs_sum": "绝对值总和",
      "both": "ℝ %",
      "broken_message": "案例研究中包含破损项目，请修复它们，否则结果可能会有偏差",
      "change": "改变",
      "charts": "图表",
      "compare": "比较",
      "copy": "复制",
      "decimal": {
        "text": "0.00",
        "title": "十进制"
      },
      "display": {
        "gross_and_percent_values": "显示总值和百分比",
        "gross_values": "显示总值",
        "hidden_items_excluded_from_sum": "隐藏的项目不包括在总和中",
        "indicators": "指标",
        "normalized_values": "显示标准化数值",
        "path": "显示路径",
        "percent_values": "显示百分比",
        "show_full_indicator_names": "显示完整的指标名称",
        "weighted_values": "显示加权值",
        "zero_values": "行数为 0"
      },
      "download_as_csv": "以 CSV 格式下载",
      "download_as_excel": "以 Excel 格式下载",
      "error_displaying_results_message": "显示结果时出现错误，请尝试重新计算",
      "expand_table": "扩展/缩减表格",
      "export": {
        "current_table": "导出当前表格"
      },
      "go_to_container": "转到选定的容器",
      "gross": "ℝ",
      "hidden": "隐藏的",
      "indicator_flow_component": {
        "flow": "流量",
        "flow_hidden": "流量 (%{hidden} 隐藏的)",
        "negative_sum": "总和（负值）",
        "others": "其它",
        "others_negative_subtotal": "其他（负值）",
        "others_positive_subtotal": "其他（正值）",
        "positive_sum": "总和（正值）",
        "sum": "总和",
        "unit": "单位",
        "weighting_factor": "系数"
      },
      "indicator_tree_component": {
        "edit_normalization": "(编辑)",
        "hide_row": "从求和结果中排除行",
        "normalization": "权重：",
        "normalization_none": "无正常化",
        "ponderation": "思考：",
        "ponderation_none": "没有思考",
        "show_row": "在求和结果中包含一行",
        "submit_normalization": "申请",
        "track": "轨道指示器在设计中"
      },
      "indicators": "指标",
      "indicators_impacts_by_dataset_component": {
        "column_80percent": "80%",
        "ecobilan": "Ecobilan",
        "indicators": "指标",
        "module": "模块",
        "no_threshold": "无阈值",
        "other": "其他 (%{num_items} 个数据集)",
        "other_dataset": "其他: %{name}",
        "other_negative": "包含负值",
        "other_positive": "包含正值",
        "phase_name": "阶段",
        "phases": "阶段",
        "sum": "绝对值之和",
        "threshold": "阈值",
        "with_energetic_mix": "+"
      },
      "indicators_set_informations": "信息",
      "indicators_set_results_tabs_component": {
        "impacts_by_dataset": "按数据集划分的冲击",
        "normalization_and_weightings": "标准化与权重分配",
        "results_by_item": "按项目显示结果"
      },
      "indicators_sets": {
        "spreadsheet": {
          "normalized": "归一化",
          "weighted": "加权"
        }
      },
      "informations": "<p>开始计算 ：</p>\n  <p class='ms-5'>1. 点击图标 <i class=\"fa-regular fa-circle-play\"></i></p>\n  <p class='ms-5'>2. 等待图标变绿 <i class=\"fa-solid fa-circle text-success\"></i></p>\n  <p class='ms-5'>3. 点击名称显示结果。</p>\n  <p class='mt-4'>如果图标为黄色 <i class=\"fa-solid fa-circle text-warning\"></i>，则您的结果不再是最新的。点击图标 <i class=\"fa-regular fa-circle-play\"></i> 重新计算。</p>\n",
      "name": "名称",
      "negative_others": "其他底片",
      "negative_others_contains": "其他底片",
      "negative_subtotal": "负数小计",
      "no_parameters_set": "未设置参数。",
      "normalized_indicators_table_component": {
        "characterisation": "特征",
        "edit_normalization": "（编辑）",
        "indicator": "指标",
        "norm_factor": "系数",
        "norm_percent": "比率",
        "norm_value": "结果",
        "normalization": "正常化",
        "normalization_none": "无正常化",
        "normalized_percentage_major": "正常化比率 (%) - 80% 以上",
        "normalized_percentage_minor": "正常化比率 (%) - 低于 20",
        "show_phases": "显示阶段",
        "submit_normalization": "提交",
        "sum": "总和",
        "sum_all_phases": "总和",
        "sum_with_module_d": "求和（含模块 D）",
        "sum_with_phases": "求和（%{num_enabled_phases}/%{num_phases} 个相位）",
        "sum_without_module_d": "总和（不含模块 D）",
        "unit": "单位 单位",
        "weighted_percentage_major": "加权比率 (%) - 80% 以上",
        "weighted_percentage_minor": "加权比率 (%) - 小于 20",
        "weighted_value": "结果",
        "weighting": "权重",
        "weighting_factor": "系数",
        "weighting_none": "无加权",
        "weighting_percent": "比率"
      },
      "options": "选项",
      "others": "其它",
      "out_of_date_results_message": "该分析结果已过时，请重新计算",
      "overview": {
        "columns": {
          "flow": "流量",
          "indicator": "环境指标",
          "name": "名称",
          "negative_sum": "负和",
          "path": "路径",
          "positive_sum": "正和",
          "sum": "总和",
          "unit": "单位",
          "unit_name": "权重系数单位",
          "weighting_factor": "加权系数名称"
        },
        "titles": {
          "indicator": "环境指标",
          "unit_name": "单位",
          "weighting_factor": "系数"
        }
      },
      "parameters_set_enabled": "激活的参数集:%{set}",
      "percentage": "%",
      "positive_others": "其他优点",
      "positive_others_contains": "其他优点",
      "positive_subtotal": "其他优点",
      "ratio": "比率:%{ratio}",
      "result_set_computation_date_component": {
        "item_not_computed": "%{item}：未计算",
        "item_outdated": "%{item}：已过时，在 %{date}计算的",
        "item_up_to_date": "%{item}: 最新",
        "not_computed": "计算中缺少一些项目",
        "outdated": "计算结果已过时。它的日期是 %{date}。",
        "up_to_date": "计算结果是最新的 (%{date})"
      },
      "scientific": {
        "text": "10<sup>n</sup>",
        "title": "科学记谱法"
      },
      "settings": "设置",
      "show_broken": "查看破损物品",
      "step": "步骤",
      "sum": "总和",
      "threshold": {
        "phase": "阶段",
        "text": "阈值",
        "title": "应用百分比阈值，以便将低于此值的数值归为一组"
      },
      "total": "总计",
      "total_others": "其他",
      "total_others_contains": "其他",
      "tree": {
        "abbreviation": "缩写",
        "calculate": "计算",
        "method": "方法",
        "name": "完整名称",
        "normalization_and_weightings": "归一化和加权",
        "select": "选择计算",
        "select_all": "选择所有",
        "source": "来源",
        "unit_name": "单位名称",
        "year": "年份"
      },
      "values": "价值观"
    },
    "cancel": "取消",
    "close": "关闭",
    "delete": "删除",
    "design": {
      "actions": {
        "back_to_parent": "返回父级",
        "collapse": "隐藏一个项目 <kbd>←</kbd>",
        "compare_item": {
          "name": "比较"
        },
        "copy": "复制 <kbd>shift + C</kbd>",
        "copy_item": {
          "name": "复制",
          "shortcut": "Maj + C"
        },
        "cut": "剪切 <kbd>shift + X</kbd>",
        "cut_item": {
          "name": "切割",
          "shortcut": "Maj + X"
        },
        "delete": "删除 <kbd>Del</kbd>",
        "delete_item": {
          "name": "删除",
          "shortcut": "Del"
        },
        "edit": "编辑 <kbd>shift + E</kbd>",
        "edit_item": {
          "name": "编辑",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "编辑线",
          "shortcut": "E"
        },
        "enter": "输入一个项目 <kbd>&crarr;</kbd>",
        "expand": "展开一个项目 <kbd>→</kbd>",
        "fix_broken": {
          "name": "修复损坏"
        },
        "in_library": "在数据库内",
        "left_region": " 从一个区域向左移动<kbd>shift + Alt + ←</kbd>",
        "navigate_down": "向下移动所选内容 <kbd>↓</kbd>",
        "navigate_up": "向上移动所选内容 <kbd>↑</kbd>",
        "navigation": "根据所选内容导航",
        "next_tab": "显示右侧标签 <kbd>shift + Alt + ↑</kbd>",
        "paste": "粘贴 <kbd>shift + P</kbd>",
        "paste_item": {
          "name": "粘贴",
          "shortcut": "Maj + P"
        },
        "previous_tab": "显示左侧标签 <kbd>shift + Alt + ↓</kbd>",
        "region": "根据地区导航",
        "reload": "更新",
        "replace": "代替",
        "right_region": " 从一个区域向右移动<kbd>shift + Alt + →</kbd>",
        "switch_down": " 从一个区域向下移动<kbd>shift + Alt + ↓</kbd>",
        "switch_up": " 从一个区域向上移动 <kbd>shift+ Alt + ↑</kbd>"
      },
      "add": {
        "dossier": {
          "name": "添加文件夹",
          "shortcut": "1"
        },
        "energy_consumption": {
          "name": "添加能耗",
          "shortcut": "5"
        },
        "folder": {
          "name": "添加文件夹",
          "shortcut": "1"
        },
        "part": {
          "name": "添加部件",
          "shortcut": "3"
        },
        "phase": {
          "name": "添加阶段",
          "shortcut": "0"
        },
        "subassembly": {
          "name": "添加子组件",
          "shortcut": "2"
        },
        "transport_step": {
          "name": "添加运输步骤",
          "shortcut": "4"
        }
      },
      "add_elements": "添加一个项目",
      "cs_flows": {
        "create": {
          "notice": "该数据流已成功添加。"
        },
        "destroy": {
          "notice": "该数据流已成功删除。"
        },
        "update": {
          "notice": "该数据流已编辑成功。"
        }
      },
      "cs_items": {
        "reject_if_cs_item_not_exist": {
          "reject": "拒绝"
        }
      },
      "cs_modules": {
        "create": {
          "notice": "该模块已成功添加。"
        },
        "destroy": {
          "notice": "该模块已成功删除。"
        },
        "update": {
          "notice": "该模块已编辑成功。"
        }
      },
      "cs_phases": {
        "create": {
          "notice": "该阶段已成功添加。"
        },
        "destroy": {
          "notice": "该阶段已成功删除。"
        },
        "update": {
          "notice": "该阶段已修改成功。"
        }
      },
      "delete_confirm": "您确定要删除这些项目吗？",
      "display": {
        "visible_columns": "可见列"
      },
      "elements_actions": "操作一个项目",
      "items_filter_component": {
        "broken_modules": "损坏的模块",
        "families": "家庭",
        "item_types": "元素类型",
        "module_types": "模块类型",
        "obsolescence": "过时",
        "phases": "阶段",
        "reset": "重置",
        "search": "搜索",
        "update": "更新"
      },
      "library": {
        "add": "添加",
        "clear": "清除",
        "deprecated_since": "已过时，因为 %{date}",
        "deprecated_soon": "数据集即将过时",
        "favorites": "收藏夹",
        "filter": {
          "family": "家庭"
        },
        "flat_version_template": "%{name} (%{version})",
        "flows": "数据流",
        "included_versions": "(包括不同版本)",
        "info": "信息",
        "latest_module_version_template": "版本 %{version} (最新): %{date}",
        "module": "模块",
        "module_version_template": "版本 %{version}: %{date}",
        "modules": "模块",
        "no_results": "无结果",
        "search": "搜索",
        "search_favorites": "Search favorites",
        "search_favorites_title": "Search favorites, conditional operator as AND, OR, NOT are available and \"\" and () as well",
        "search_flows": "Search flows",
        "search_flows_title": "Search flows, conditional operator as AND, OR, NOT are available and \"\" and () as well",
        "search_modules": "Search datasets",
        "search_modules_title": "Search datasets, conditional operator as AND, OR, NOT are available and \"\" and () as well",
        "search_systems": "Search systems",
        "search_systems_title": "Search systems, conditional operator as AND, OR, NOT are available and \"\" and () as well",
        "shared_by": "%{item_name} - shared by %{user_name}",
        "systems": "系统"
      },
      "name": "Nom",
      "overview": {
        "columns": {
          "badges": {
            "reusable": "<p><strong>可重复使用</strong></p>\n<p>如果在产品生命周期结束时，可以为相同或其他功能重复使用，而不改变其所含材料，则该产品或部件是可重复使用的</p>\n",
            "use_as_process": "<p><strong>如果在产品生命周期结束时，可以为相同或其他功能重复使用，而不改变其所含材料，则该产品或部件是可重复使用的</strong></p>\n<p>指货物制造过程中消耗的材料或部件，该货物的材料成分中没有这种材料或部件</p>\n"
          },
          "category_with_inheritance": "类别",
          "comments": "评论",
          "computed_quantity": "累计数量",
          "created_at": "创建日期",
          "ecobilan_identifier": "Eco. Id",
          "ico": "Ico",
          "id": "EIME 标识符",
          "loss_rate_percentage": "损失率百分比",
          "lr": "LR",
          "name": "名称",
          "net_calorific_value": "LHV",
          "path": "路径",
          "quantity": "数量",
          "quantity_formula": "数量公式",
          "rank": "#",
          "renewable_p": "RP",
          "second_quantity": "第二量",
          "state": "状态",
          "titles": {
            "category_with_inheritance": "类别（具有继承性）",
            "comments": "评论 [Com.]",
            "computed_quantity": "累计数量",
            "created_at": "创建于",
            "ecobilan_identifier": "Ecobilan 标识符 [Eco. Id]",
            "ico": "图标 [Ico]",
            "id": "Id",
            "loss_rate_percentage": "损失率百分比",
            "lr": "损失率 (%) [LR]",
            "name": "名称",
            "net_calorific_value": "较低的热值 [LHV]",
            "path": "路径",
            "quantity": "数量",
            "rank": "职位 [#]",
            "renewable_p": "可再生材料 (%) [RP]",
            "second_quantity": "第二数量 [Sec. Qua.]",
            "state": "国家",
            "tracking_gross": "跟踪毛额",
            "tracking_percent": "跟踪百分比",
            "updated_at": "更新于",
            "use_as_process": "在加工过程中使用 [UDP]"
          },
          "tracking": "跟踪",
          "tracking_gross": "目标",
          "tracking_percent": "目标 (%)",
          "updated_at": "修改日期",
          "use_as_process": "UCP"
        }
      },
      "partials": {
        "tracking_button": {
          "flows": "流量",
          "none": "删除当前跟踪",
          "relative_to_case_study": "相对于案例研究的百分比",
          "relative_to_phase": "相对于相位的百分比",
          "relative_to_view": "相对于当前视图的百分比"
        }
      },
      "replace": {
        "all": "替换案例研究的所有相同元素。",
        "btn": "替换",
        "db_flow_uuid": "流量数据集的 ext_id，例如：f54a4bc1-68ef-4332-a1a2-760ad5b72168",
        "errors": {
          "db_item_not_found": "找不到包含此标识符的项目：%{id}",
          "db_item_not_provided": "请提供新的数据集",
          "replace_fail": "替换失败，请重试或联系 EIME 支持人员"
        },
        "new": "新",
        "previous": "上一页",
        "replace_all_is_unavailable": "全局替换（替换案例研究中的所有相同元素）不适用于本数据集",
        "title": "替换一个项目"
      },
      "search": {
        "search_elements": "在案例研究中搜索"
      },
      "search_case_study": "在案例分析中搜索",
      "searches": {
        "case_study": "在案例分析内搜索 <kbd>shift + f </kbd>",
        "library": "在激活的数据库内搜索 <kbd>f<kbd>",
        "project": "在工程项目内搜索 <kbd>shift + Alt + f<kbd>",
        "title": "搜索"
      },
      "shortcuts": "键盘快捷键",
      "show_shortcuts": "显示快捷键 <kbd>shift + ?</kbd>",
      "tracking_off": "捐款",
      "tracking_on": "锁定 %{indicator_name}",
      "tree": {
        "containers": "容器",
        "expand_all": "展开"
      }
    },
    "front": {
      "actions": {
        "confirm": {
          "archive_database_upgrade_chronicle": "Do you confirm you want to archive this upgrade ? All upgrades that ran before this one will also be archived, if they are not already.",
          "delete_database_upgrade_step": {
            "one": "⚠️ 目前，此步骤关联了一个数据集。如果您删除此步骤，该数据将从自动升级流程中移除。您确认要删除吗？",
            "other": "⚠️ 当前有 %{count} 个数据集与该步骤关联。如果您删除该步骤，这些数据集将从自动更新流程中移除。您确定要删除该步骤吗？",
            "zero": "您确定要删除它吗？此操作的风险较低，因为此步骤未关联任何数据集。"
          },
          "delete_item": "您确定要删除这些项目吗？",
          "launch_database_upgrade_step": "Selected step: %{name}. Do you confirm the launch of this upgrade ?",
          "make_available": "您确认该商品是否有货？从今天开始供应。该行动不可逆转。",
          "prune_items": "您确定要删除所有数量设为零的项目吗？"
        },
        "errors": {
          "contact_support": "出错了，请联系 EIME 支持。",
          "unauthorized": "不允许执行此操作。"
        },
        "name": {
          "add_case_study": "Add case study",
          "add_category": "添加类别",
          "add_company": "Add a company",
          "add_database_upgrade_step": "添加一个步骤",
          "add_db_module_substitution": "定义替换",
          "add_dossier": "添加文件夹",
          "add_energy_consumption": "增加能耗",
          "add_flow": "添加流量",
          "add_indicator": "添加指标",
          "add_indicators_set": "添加指标集",
          "add_instance": "Add an instance",
          "add_item": "添加项目",
          "add_linked_module": "Add as linked dataset",
          "add_linked_module_types": {
            "end_of_life": "End of life",
            "linked_process": "Process",
            "module_d": "Module D"
          },
          "add_module": "创建模块",
          "add_module_version": "新版本",
          "add_part": "添加部件",
          "add_phase": "添加阶段",
          "add_project": "Add project",
          "add_subassembly": "添加子组件",
          "add_tag": "添加标签",
          "add_transport_step": "添加运输步骤",
          "add_user": "Add a user",
          "archive_item": "档案",
          "bookmark": "Bookmark",
          "cancel_database_upgrade_chronicle": "Cancel this upgrade",
          "check": "数据集检查",
          "compare_db_modules": "Compare",
          "copy_item": "复制",
          "copy_ref_id": "Copy ref id",
          "cut_item": "切割",
          "define_global_template": "Define as global template",
          "delete_item": "删除",
          "deprecate": "使之过时",
          "download_case_study_source": "下载案例研究资料",
          "duplicate": "Duplicate",
          "duplicate_item": "重复项目",
          "edit_contributors": "编辑贡献者",
          "edit_expiration_date": "Edit expiration date",
          "edit_icv": "编辑 LCI",
          "edit_item": "编辑",
          "edit_line": "编辑线",
          "edit_manager": "Edit manager",
          "edit_normalization": "编辑规范化",
          "edit_parameters": "参数",
          "edit_ponderation": "编辑思考",
          "edit_rank": "Edit rank",
          "edit_scenarios": "编辑方案",
          "edit_tokens": "Edit Tokens",
          "edit_workflow_and_publication_status": "地位",
          "export": {
            "analysis": "分析 (高级)",
            "analysis_json": "Analysis (advanced JSON)",
            "comparison": "对比",
            "design": "设计",
            "eime": "Eime",
            "inies": "Inies",
            "json_case_study": "Design JSON",
            "multi_tracking": "设计 (所有轨迹)",
            "name": "导出",
            "pep_ecopassport": "PEP Ecopassport",
            "simplified_analysis": "分析",
            "simplified_analysis_json": "Analysis (JSON)",
            "tracking": "设计 (当前跟踪)"
          },
          "export_database_upgrade_chronicle": "Export the change report",
          "export_module": "出口",
          "find_in_library": "Find in library",
          "fix_broken": "修复损坏",
          "forward": "转发",
          "go_to_comparison": "Go to comparison",
          "import_case_study": "Import case study",
          "import_case_study_here": "Import case study in this folder",
          "import_module": "导入模块",
          "info_item": "信息",
          "launch_database_upgrade_step": "Launch this upgrade",
          "make_available": "发布",
          "mark_as_favorite": "标记为收藏",
          "paste_item": "粘贴",
          "paste_item_here": "Paste in this element",
          "permissions": "权限",
          "prune_items": "Clean up the model",
          "recompute_broken": "Recompute broken items",
          "refresh_children": "为子实例刷新数据库",
          "refresh_module_impacts": "计算影响",
          "reinitialize": "Reinitialize state",
          "remove_analysis_results": "Remove analysis results",
          "remove_from_favorite": "从收藏中删除",
          "remove_global_template": "Remove from global templates",
          "replace_cs_modules": "Datasets",
          "replace_cs_transport_steps": "Transport steps",
          "replace_item": "Substitute",
          "reset_item_path": "重新计算 item_path",
          "share": "Share",
          "status": "Status",
          "transform_to_module": "转换为模块",
          "transform_to_template": "Transform to template",
          "unarchive_item": "解压缩",
          "unmark_as_template": "Unmark as template",
          "unshare": "Unshare",
          "update_items": "更新模块"
        },
        "restriction": {
          "paid_licence": "付费许可证"
        },
        "title": {
          "add_case_study": "Add case study",
          "add_category": "添加类别",
          "add_dossier": "添加文件夹",
          "add_energy_consumption": "增加能耗",
          "add_item": "添加项目",
          "add_part": "添加部件",
          "add_phase": "添加阶段",
          "add_project": "Add project",
          "add_subassembly": "添加子组件",
          "add_transport_step": "添加运输步骤",
          "archive_item": "档案",
          "bookmark": "Bookmark",
          "compare_db_modules": "Compare",
          "copy_item": "复制",
          "copy_ref_id": "Copy ref id",
          "cut_item": "切割",
          "define_global_template": "Define as global template",
          "delete_item": "删除",
          "download_case_study_source": "下载案例研究资料",
          "duplicate": "Duplicate",
          "duplicate_item": "重复项目",
          "edit_contributors": "编辑贡献者",
          "edit_expiration_date": "Edit expiration date",
          "edit_icv": "编辑 LCI",
          "edit_item": "编辑",
          "edit_line": "编辑线",
          "edit_manager": "Edit manager",
          "edit_normalization": "编辑规范化",
          "edit_parameters": "参数",
          "edit_ponderation": "编辑思考",
          "edit_scenarios": "编辑方案",
          "edit_tokens": "Edit Tokens",
          "edit_workflow_and_publication_status": "地位",
          "export": {
            "analysis": "分析 (高级)",
            "analysis_json": "Analysis (advanced JSON)",
            "comparison": "分析",
            "design": "设计",
            "eime": "Eime",
            "inies": "Inies",
            "json_case_study": "Design JSON",
            "multi_tracking": "设计 (所有轨迹)",
            "name": "导出",
            "pep_ecopassport": "PEP Ecopassport",
            "simplified_analysis": "分析",
            "simplified_analysis_json": "Analysis (JSON)",
            "tracking": "设计 (当前跟踪)"
          },
          "export_module": "出口",
          "find_in_library": "Find in library",
          "fix_broken": "修复损坏",
          "forward": "转发",
          "go_to_comparison": "Go to comparison",
          "import_case_study": "Import case study",
          "import_case_study_here": "Import case study in this folder",
          "info_item": "信息",
          "make_available": "发布",
          "mark_as_favorite": "标记为收藏",
          "paste_item": "粘贴",
          "paste_item_here": "Paste in this element",
          "permissions": "权限",
          "prune_items": "数量为空的垃圾物品",
          "recompute_broken": "Recompute broken items",
          "refresh_module_impacts": "计算影响",
          "reinitialize": "Reinitialize state",
          "remove_analysis_results": "Remove analysis results",
          "remove_from_favorite": "从收藏中删除",
          "remove_global_template": "Remove from global templates",
          "replace_cs_modules": "Substitute datasets",
          "replace_cs_transport_steps": "Substitute transport steps",
          "replace_item": "Substitute",
          "reset_item_path": "重新计算 item_path",
          "share": "Share",
          "status": "Status",
          "transform_to_module": "转换为模块",
          "transform_to_template": "Transform to template",
          "unarchive_item": "解压缩",
          "unmark_as_template": "Unmark as template",
          "unshare": "Unshare",
          "update_items": "更新模块"
        }
      },
      "check_session_timeout": {
        "disconnect": "断开",
        "reconnect": "重新连接",
        "stay_connected": "保持联系",
        "stay_connected_timer": "保持联系 (%{seconds_left})",
        "too_late_message": "由于闲置时间过长，您的会话已被断开",
        "warning_timeout": "您的会话即将到期。如果您不采取任何行动，您将很快被断开连接。"
      },
      "controllers": {
        "analysis_flow_table": {
          "track_flow": "设计中的轨道流"
        },
        "current_view": {
          "view_changed": "本页面已更改，点击刷新"
        },
        "date_validator": {
          "not_a_valid_date": "must be a valid date"
        },
        "debug/running_queries": {
          "confirm_kill": "杀死进程 %{pid} ? 这可能会使整个数据库重新启动。",
          "confirm_terminate": "停止请求 %{pid}?",
          "kill": "关闭 postgresql 进程",
          "terminate": "终止请求"
        },
        "infinite_scroll": {
          "more_items": "加载更多项目..."
        },
        "make_cs_module": {
          "discard_unsaved": "丢弃未保存的更改？"
        },
        "parameters": {
          "destroy_parameter": "Are you sure you want to destroy this parameter ?",
          "destroy_parameters_set": "Are you sure you want to destroy this parameters set ?",
          "download": "在下载中找到您的文件。",
          "error": "Error",
          "saved": "Saved",
          "saving": "Saving..."
        },
        "step_form": {
          "discard_unsaved": "丢弃未保存的更改？",
          "errors_occured": "请检查表格，保存时出现了一些错误"
        }
      },
      "database": {
        "publish": {
          "success": "您的项目已发布"
        }
      },
      "interface": {
        "admin": "管理",
        "analysis": "分析",
        "comparison": "对比",
        "database": "资料库",
        "design": "设计",
        "home": "首页",
        "project": "项目"
      },
      "long_poll": {
        "disconnected": "点击刷新页面"
      },
      "ping": {
        "check_websockets": "检查 WebSockets",
        "warning_missing_websockets": "<p>为了提高 EIME 的性能，我们将在短期内采用 WebSocket。</p>\n<p>如果贵公司禁止使用 WebSocket 协议，请联系我们的 IT 部门或贵公司的 IT 部门。</p>\n"
      }
    },
    "helpers": {
      "true_admin_only": {
        "admin": "管理员",
        "visible_only_to_admins": "仅管理员可见"
      }
    },
    "make": {
      "actions": {
        "close": "关闭",
        "extract": "在新窗口中提取",
        "minimize": "最小化"
      },
      "choose_parent": {
        "add_phase": "添加阶段",
        "choose_parent": "请为您的物品选择一个生命周期阶段。",
        "create_phase": "请先创建生命周期阶段，然后再添加其他项目。",
        "submit": "继续"
      },
      "create": {
        "notice": "通知"
      },
      "cs_case_studies": {
        "clear_template": {
          "notice": "The case study is not a template anymore."
        },
        "create": {
          "notice": "通知"
        },
        "export": {
          "notice": "导出中..."
        },
        "form": {
          "database": "Databases",
          "database_selector": "All databases",
          "general_information": "参数",
          "incoming": "传入的",
          "incoming_tooltip": "“损耗率 \"是根据损耗量与进料量的关系来表示的，计算公式如下： 损耗率=损耗量/进料量<br>该方法是行业内常用的方法，在 EIME 中默认使用\"。",
          "informations": "信息",
          "no_energetic_mix_marked_as_favorite": "未将任何能量混合物标记为收藏",
          "outgoing": "即将发生",
          "outgoing_tooltip": "“损耗率 \"是根据损耗量与出料量的比例来表示的，计算公式如下： 损耗率=损耗量/运出量<br>这种方法是 PEP Ecopassport 计划假设中默认使用的方法\"。",
          "pep_compliant_loss_rate_change_label": "与材料有关的损失百分比",
          "pep_compliant_loss_rate_change_message": "请注意，您已更改了计算损失量的方法。这一更改将影响您的结果",
          "popover_content": "默认情况下，损耗是根据入库物料计算的，即损耗率 = 损耗数量 / 入库数量。可以更改损耗的计算方法，使其与出库物料相关，即损耗率 = 损耗数量 / 出库数量",
          "popover_title": "损失率计算",
          "template_comments": "模板评论"
        },
        "import": {
          "cs_counter_limit_exceeded": "您当前的许可证不允许您创建更多案例研究。您还有%{file_limit}个案例研究，但您试图导入%{files_imported}个。",
          "file_import_limit_exceeded": "You have selected more than %{file_limit} case studies.<br>\nTo ensure optimal performance, please limit your selection.\n",
          "notice": "您的导入正在进行中。"
        },
        "indicators_set": {
          "error": "错误",
          "notice": "通知"
        },
        "mark_template": {
          "notice": "该案例研究已被标记为模板"
        },
        "new": {
          "cs_counter_limit_exceeded": "您当前的许可证不允许您创建更多案例研究。"
        },
        "update": {
          "notice": "案例研究修改成功。"
        },
        "upload_button": "上传"
      },
      "cs_containers": {
        "create": {
          "notice": "该容器已成功添加。",
          "system": "正在建立系统。"
        },
        "destroy": {
          "notice": "容器已成功删除。"
        },
        "form": {
          "category_with_inheritance": "继承类别 : %{inherited_category}",
          "container_type": "Container type",
          "general_information": "参数",
          "no_category": "无",
          "title": {
            "dossier": "集装箱",
            "part": "部分",
            "phase": "System phase",
            "subassembly": "子组件"
          }
        },
        "update": {
          "notice": "容器已成功修改。"
        }
      },
      "cs_energy_consumptions": {
        "form": {
          "general_information": "参数",
          "title": {
            "energy_consumption": "能量消耗"
          }
        }
      },
      "cs_flows": {
        "form": {
          "general_information": "参数",
          "title": {
            "category": "Category",
            "flow": "流量"
          }
        },
        "multi_replace": {
          "success": {
            "one": "%{count}项已成功替换。",
            "other": "%{count}项已成功替换。"
          }
        },
        "new_multi_replace": {
          "disclaimer_units": "如果新数据集所需的单位组（质量、公制......）与旧数据集不同，新数据集将被分配一个新的默认单位",
          "disclaimer_values": "将旧模块或流程中的值系统地转移到新模块或流程中",
          "title": "Substitute"
        }
      },
      "cs_folders": {
        "form": {
          "general_information": "参数",
          "title": {
            "folder": "文件夹"
          }
        }
      },
      "cs_items": {
        "admin_recompute_broken": {
          "notice": "Recomputing broken modules in progress..."
        },
        "bookmark": {
          "add": " 现在，该项目已成为您收藏夹的一部分。您可以在 “系统 ”选项卡中找到它。",
          "remove": "该项目不再属于您的收藏夹。"
        },
        "create": {
          "success": " 该项目已成功创建。"
        },
        "forward_chown": {
          "error": "无法前进。",
          "success": {
            "one": "项目正在转发。",
            "other": "正在转发的项目。"
          }
        },
        "forward_copy": {
          "error": "无法转发和复制。",
          "success": {
            "one": "项目正在转发。",
            "other": "正在转发的项目。"
          }
        },
        "move": {
          "error": {
            "phase_moves_only_in_case_study": "一个阶段只应是案例研究的根本。"
          }
        },
        "multi_destroy": {
          "success": {
            "one": "该项目正在被删除。",
            "other": "这些项目正在被删除。"
          }
        },
        "multi_destroy_message": {
          "default": "您想将 %{num_items} 项目扔进垃圾桶吗？",
          "error_unlink_energetic_mix": "如果没有父模块，就不能将能量混合模块扔进垃圾桶。",
          "with_linked": "您想将 %{num_items} 项目（包括 %{num_linked} 链接模块）扔进垃圾桶吗？"
        },
        "multi_fix_broken": {
          "notice": "正在修理模块..."
        },
        "multi_update": {
          "success": "项目已更新成功。"
        },
        "multi_update_version": {
          "notice": "正在更新模块..."
        },
        "paste": {
          "error": {
            "cannot_paste_inside_itself": "项目不能粘贴到自身内部。",
            "cannot_paste_trashed": "剪贴板中的一个或多个项目被删除。如果要粘贴，请恢复这些项目。",
            "case_study_restrictions": "一个案例研究不能放在另一个案例研究中。",
            "containers_restrictions": "容器（文件夹、子组件、部件）必须放置在相位或另一个容器内。",
            "folder_restrictions": "项目文件夹不能放在案例研究中。",
            "leafs_restrictions": "流程、模块、运输步骤和能耗必须置于一个阶段或容器内。",
            "module_d_restrictions": "一个案例研究只允许有一个模块 D 类型的阶段。",
            "no_items": " 没有项目要粘贴。",
            "one": "该项目不能被粘贴。",
            "other": "这些项目不能被粘贴。",
            "phase_restrictions_duplicate": "一个阶段必须粘贴在案例研究根目录、另一个阶段或容器中。",
            "phase_restrictions_move": "阶段只能在案例研究根中移动。"
          }
        },
        "reinitialize": {
          "success": {
            "one": "该项目已成功初始化。",
            "other": "这些项目已成功初始化。"
          }
        },
        "reject": "您无法执行操作或浏览无效的项目",
        "reject_insert": " 您不能在案例研究的根目录中插入此元素。",
        "share": {
          "add": "该项目是共享的。您可以在 “系统 ”选项卡中找到它。",
          "remove": "该项目不再共享。"
        },
        "track": {
          "notice": "跟踪已成功更新。"
        },
        "update": {
          "success": "更新成功。"
        }
      },
      "cs_module_form": {
        "common_fields_component": {
          "popover_secondary_quantity_formula": "模块的影响 = LCI * 第一个量的值 * （第二个量的值 / 第二个量的参考值）"
        },
        "preload_scenario_component": {
          "creation": "创建数据集",
          "energetic_mix_shortcut": "快捷方式--自动填充能量组合"
        }
      },
      "cs_modules": {
        "form": {
          "add": "添加",
          "add_module": "+&nbsp;&nbsp;模块",
          "add_scenario": "+&nbsp;&nbsp;场景",
          "advanced_parameters": "高级参数",
          "broken": "Broken dataset",
          "creating": "制作中",
          "db_module_not_found": "未找到数据集。",
          "deprecated_soon": "过时的模块",
          "deprecated_soon_popover": "对于日期在 %{date} 年之前的项目，该数据将被淘汰，数据库中通常有更合适的替代数据。",
          "documentation": "查看完整文档",
          "end_of_life": "生命的终结",
          "energetic_mix": "活力混合",
          "favorite_mixes": "收藏",
          "forbidden_scenario": "这种情况与您的项目日期或许可证不符。",
          "general_information": "一般信息",
          "info_ecobilan_id": "Ecobilan Id.",
          "info_module_uuid": "模块 UUID",
          "info_version": "版本（提供日期）",
          "information": "信息",
          "linked_process": "版本",
          "loss_rate_percentage_variable": "Lr",
          "loss_rate_variable_math": "<msub><mi>L</mi><mi>r</mi></msub>",
          "main_module": "主模块",
          "module_d": "模块 D",
          "non_favorite_mixes": "其他",
          "quantity_including_losses": "包括损失在内的数量",
          "quantity_losses": "包括损失在内的数量 : ",
          "quantity_variable": "Q",
          "quantity_variable_math": "<mi>Q</mi>",
          "renewable_percentage_hint": " 可再生百分比表示产品重量来自可再生资源的百分比，例如可持续林业。",
          "second_parameters_html": "该模块在 <b>%{min}</b> 和 <b>%{max}</b> %{unit} 之间具有代表性。",
          "second_parameters_name_html": "该模块以下列标准 <b>%{name}</b> 作为第二个参数进行建模",
          "second_quantity_variable": "Q2",
          "select_a_scenario": "选择情景",
          "submit": "保存并关闭",
          "update": "节省",
          "warning_partly_terminated": "请注意，该数据集仅为部分数据。\n请参考文档并按照 “数据集使用建议 ”部分的说明完成此数据。\n如果这些数据提供了流程场景，您必须将其添加以完成数据。\n"
        },
        "show": {
          "read_only_flag": "Read-only"
        },
        "update": {
          "notice": "模块已更新"
        }
      },
      "cs_phases": {
        "form": {
          "general_information": "参数",
          "title": {
            "phase": "阶段"
          }
        }
      },
      "cs_projects": {
        "create": {
          "success": "项目已成功创建。"
        },
        "form": {
          "general_information": "参数",
          "title": {
            "project": "项目"
          }
        },
        "update": {
          "success": "项目已成功更新。"
        }
      },
      "cs_systems": {
        "create": {
          "system": "系统"
        },
        "form": {
          "create": "Add a system",
          "title": {
            "system": "系统"
          }
        },
        "new": {
          "advanced_insertion": "Advanced insertion",
          "advanced_insertion_description": "Choose where and what part of the system you want to insert within your case study.",
          "create": "添加系统",
          "expected_lifetime": "使用寿命",
          "functional_unit_ratio": "功能单元比率",
          "general_information": "参数",
          "in": "in",
          "information": "信息",
          "insert_in_phase": "在 %{phase_name}",
          "insert_phase": "插入相位",
          "insert_phases_methods": "相位插入法",
          "not_allowed": "A system cannot be inserted at the root of a case study.",
          "quick_insertion": "Quick insertion",
          "quick_insertion_description": "Insert the whole system within your current location",
          "real_weight": "实际重量",
          "title": "添加系统",
          "warning": "功能单元比率是指示性的，在本研究中不予考虑。"
        }
      },
      "cs_transport_steps": {
        "edit": {
          "title": "编辑一个%{name}"
        },
        "form": {
          "average_load_percentage_information": "运输步骤公式是针对平均负荷超过 50%的情况制定的。",
          "general_information": "参数",
          "header": "运输步骤"
        },
        "new": {
          "title": "添加运输步骤"
        }
      },
      "db_flows": {
        "form": {
          "general_information": "参数"
        },
        "publish": {
          "success": "流程已经公布。"
        }
      },
      "db_module_from_cs_case_studies": {
        "new": {
          "back": "返回",
          "force_type_of_dataset": "强制数据集类型（默认留空）"
        },
        "new_preset": {
          "recommendation": "您即将开始根据案例研究制作数据集的过程。\n请检查您的案例研究是否符合最新的数据集版本，并且不包含任何损坏的元素。\n"
        }
      },
      "db_module_scenarios": {
        "breadcrumb": {
          "title": "[%{ecobilan}] 的情景"
        },
        "copy_scenarios": {
          "all_linked_modules_types": "全部",
          "any_version": "适用于所有版本的数据集 %{ecobilan}",
          "provider": "提供情景的数据集",
          "quantity_formula": "新的数量公式",
          "second_quantity_formula": "新的第二数量公式（如有必要）",
          "select_scenarios_type": "选择方案",
          "submit": "开始复制",
          "subtitle": "复制方案",
          "title": "%{name} 的情景",
          "update_quantity_formula": "更新数量公式"
        },
        "edit": {
          "title": "%{name} 的情景"
        },
        "form": {
          "new_module": "添加模块"
        },
        "form_for_scenario_linked_module_component": {
          "could_not_find_module_in_database": "数据库中找不到该模块。",
          "destroy_confirm": "您确认删除该模块吗？",
          "popover_content": "您必须在此写出一个公式，其中至少包含以下一个变量 ： <br><br> <strong>· containers_quantity<br>· quantity_with_losses<br>· quantity_without_losses<br>· quantity_losses<br>· second_quantity</strong><br><br>示例<br>quantity_with_losses * 3.14",
          "popover_title": "公式",
          "remove_module": "移除"
        },
        "index": {
          "add_description": "为您的数据集创建新情景。",
          "add_title": "添加",
          "copy_description": "从另一个数据集添加场景。",
          "copy_title": "复制",
          "delete_description": "快速删除多个方案，可按类型过滤。",
          "delete_title": "删除",
          "see_scenarios_list": "要查看、编辑或删除现有情景，可使用右侧的列表。",
          "subtitle": "可能的操作",
          "title": "%{name} 的情景"
        },
        "multi_destroy": {
          "confirm": "您确定要删除所选情景吗？此操作不可逆。",
          "delete_scenarios": "请选择一种或多种类型的情景进行删除。所选情景包括当前版本的情景以及适用于所有版本的数据集的情景。",
          "submit": "删除",
          "subtitle": "快速删除",
          "title": "%{name} 的情景"
        },
        "new": {
          "subtitle": "新方案",
          "title": "%{name} 的情景"
        },
        "scenarios_list": {
          "all": "一应俱全",
          "for_any_version": "适用于任何模块版本",
          "for_version": "适用于版本 %{version}",
          "no_scenario": "没有场景。",
          "scenarios_count": "现有方案 (%{count})",
          "search": "搜索",
          "search_by_name": "按名称搜索"
        },
        "show": {
          "add": "新方案",
          "destroy": "删除",
          "destroy_confirm": "您是否确认删除了这一情景？",
          "edit": "编辑",
          "title": "%{name} 的情景"
        }
      },
      "db_modules": {
        "check": {
          "go_to_form": "返回表格"
        },
        "check_rules": {
          "check_failed": "有些检查没有通过。",
          "check_run": "对您的数据集类型 运行了以下检查",
          "check_successful": "所有检查均通过。",
          "mandatory": "强制性规则",
          "optional": "良好做法",
          "title": "数据集检查"
        },
        "edit_available_date": {
          "go_to_form": "返回表格",
          "ignore_and_make_available": "忽略并提供",
          "invalid_db_module": "缺少部分信息。",
          "make_available": "宣布可用性",
          "missing_information": "在提供数据集之前，您仍需填写或更正以下信息："
        },
        "edit_deprecated_date": {
          "add_substitution_dataset": "添加新的替换数据集",
          "confirm": "您确认这种过时吗？这一行动不可逆转。",
          "delete_substitution_dataset": "删去",
          "deprecate_all_versions": "废弃该数据集的所有版本。",
          "deprecate_all_versions_subtitle": "提示：如果选择废弃所有版本的数据，可以定义替代数据，为用户选择替代数据提供建议。",
          "scenarios_available": {
            "one": "%{count} 个可用场景",
            "other": "%{count} 个可用场景",
            "zero": "没有可用场景"
          },
          "submit": "节省",
          "title": "过时管理"
        },
        "form": {
          "generic_publication": "出版要求",
          "not_component_publication": "要求出版，但部件除外",
          "not_uap_publication": "必须公布，但不含材料的工艺除外"
        },
        "form_for_available_date_component": {
          "confirm": "您确认是否有该商品？此操作不可逆转。",
          "irreversible": "最终和不可逆转的出版",
          "please_pick_date": "符合 EIME 规定的最低要求（注意：此检查不能取代验证）。\n您的数据可以发布。请选择可用日期。\n",
          "submit": "提供",
          "title": "提供"
        },
        "form_for_multi_available_date_component": {
          "confirm": "您能确认这些物品的可用性吗？此行动不可逆转。",
          "has_errors": "无法发布 %{count} 数据集中的 %{count_errors}。\n请逐个检查这些数据集的信息：\n",
          "irreversible": "最终且不可逆转的发布",
          "please_pick_date": "将发布 %{count} 个数据集",
          "submit": "发布",
          "title": "发布多个数据集"
        },
        "form_for_workflow_and_publication_status_component": {
          "help_content": "<strong>工作草案：</strong><p>数据集处于持续开发的初步状态。</p>\n<strong>供内部审查的最终草案：</strong><p>数据集已完成，可进行内部审查。</p>\n<strong>供外部审查的最终草案：</strong><p>数据集已准备就绪，可进行外部评审（在可能的内部评审和必要的修正之后）。</p>\n<strong>数据集定稿；未发表：</strong><p>数据集已定稿（已进行或未进行内部和/或外部评审以及必要的更正），但尚未或尚未发表。</p>\n<strong>正在修订：</strong><p>数据集正在修订中，预计将发表修订后的数据集。</p>\n<strong>数据集定稿；已全部出版：</strong><p>数据集已定稿（无论是否经过内部和/或外部审查和校正），并已全部发表。</p>\n",
          "help_title": "状态",
          "irreversible": "最终和不可逆转的出版",
          "keep": "保留当前版本 (%{ext_version})",
          "major_upgrade": "主要升级 (%{ext_version})",
          "manual": "手动选择版本",
          "minor_upgrade": "小规模升级 (%{ext_version})",
          "submit": "提交",
          "title": "编辑状态",
          "versionning_options": "更新版本（仅在最终出版的情况下）"
        },
        "multi_update_available_date": {
          "success": "您的数据集现已可用。"
        },
        "refresh_impacts": {
          "success": "更新了模块的影响。"
        },
        "update_available_date": {
          "success": "该模块现已推出。"
        }
      },
      "destroy": {
        "notice": "通知"
      },
      "error": {
        "title": "错误"
      },
      "indicators": {
        "publish": {
          "success": "指标已公布。正在刷新影响。此操作可能需要几分钟。"
        },
        "toggle_archive": {
          "success": "该指标已更新"
        }
      },
      "indicators_sets": {
        "form": {
          "create": "创建",
          "edit": "编辑指标集",
          "new": "新指标集",
          "published_on": "出版日期 %{available_date}",
          "update": "更新"
        },
        "publish": {
          "success": "这套指标已经公布。"
        },
        "toggle_archive": {
          "success": "已更新整套指标"
        }
      },
      "make_forms": {
        "already_opened": "打开第一个表格时无法打开第二个表格"
      },
      "modules": {
        "information": "信息",
        "new": "添加一个%{model}"
      },
      "multi_replace": {
        "replacement_report_component": {
          "error": {
            "one": "有一个项目没有被替代：",
            "other": "这 %{count} 件物品未被更换："
          },
          "no_items_found": "No dataset corresponding to your request has been found. No substitution has been made.",
          "success": {
            "one": "一个项目已被替换：",
            "other": "这些 %{count} 项目已被替换："
          },
          "title": "您要求用 <strong>%{old_db_module_name}</strong> 替换 <strong>%{new_db_module_name}</strong>。"
        }
      },
      "normalizations": {
        "form": {
          "back": "返回",
          "delete": "删除",
          "edit": "编辑",
          "factors": "归一化系数",
          "new": "新常态化",
          "page_title": "标准化 %{indicators_set}"
        },
        "index": {
          "page_title": "标准化 %{indicators_set}"
        }
      },
      "panel_component": {
        "create": "创建",
        "update": "更新"
      },
      "partials": {
        "panel": {
          "create": "创建",
          "update": "更新"
        }
      },
      "permissions_component": {
        "change": "改变",
        "non_recursive_permissions": {
          "no_access": "无访问权限",
          "owner": "业主",
          "readable": "只读 仅访问某些元素",
          "undefined": "无许可",
          "writable": "只能访问某些元素"
        },
        "reason": {
          "admin": "自动（管理员）",
          "inherited": "从父文件夹继承",
          "manager": "自动 (经理)",
          "manual": "由业主设定",
          "no_perm": "未设置",
          "owner": "自动 (所有者)",
          "owner_manager": "自动 (经理)"
        },
        "recursive_permissions": {
          "no_access": "无访问权限",
          "readable": "只读访问",
          "undefined": "无许可",
          "writable": "完全访问"
        },
        "set_non_recursive_permissions": {
          "no_access": "禁止进入",
          "readable": "只能读取授权子元素",
          "writable": "只能对授权子元素进行写入访问"
        },
        "set_recursive_permissions": {
          "no_access": "禁止进入",
          "readable": "读取所有包含的元素",
          "writable": "对所有包含元素的写入访问权限"
        },
        "title_permissions": {
          "no_access": "未经授权的访问",
          "readable": "阅读",
          "writable": "创建访问"
        },
        "unset_permissions": {
          "no_access": "停止禁止访问",
          "readable": "删除读取访问",
          "writable": "删除写入访问"
        }
      },
      "ponderations": {
        "form": {
          "back": "返回",
          "delete": "删除",
          "edit": "编辑",
          "factors": "思考因素",
          "new": "新的思考",
          "page_title": "思考 %{indicators_set}"
        },
        "index": {
          "page_title": "思考 %{indicators_set}"
        }
      },
      "refresh": {
        "index": {
          "refresh_instances": "Refresh Instances"
        },
        "show_instance": {
          "instance": "Instance %{name}",
          "last_refresh": "Last refresh at %{date}",
          "last_refresh_error": "Last refresh failed at %{date}",
          "last_update": "database version: %{date}",
          "number_of_flows": "%{count} flows",
          "number_of_modules": "%{count} modules",
          "refresh": "Refresh",
          "refresh_confirm": "Refreshing database is a lengthy operation and the database seems up to date, are you sure you want to continue?",
          "refresh_progress": "Refresh %{step_num}/%{step_max}: %{step_name}",
          "refresh_requested": "Refresh requested",
          "refresh_step": {
            "compute_flow_impacts": "Compute flow impacts",
            "compute_module_impacts": "Compute datasets impacts",
            "copy_immutable_impacts": "Copy immutable impacts",
            "copy_mutable_impacts": "Copy mutable impacts",
            "refresh_database": "Copying database %{table_name}",
            "remove_obsolete_impacts": "Cleaning obsolete impacts"
          },
          "up_to_date": "Database up to date"
        }
      },
      "replace": {
        "cs_modules": {
          "form_component": {
            "choose_energetic_mix": "充满活力的组合",
            "quantity_action": {
              "keep": "保持当前值",
              "reset": "使用新数据集默认的第二个数量",
              "use_ratio": "使用比率"
            },
            "recommended": "推荐数据集",
            "replace_all_is_unavailable": "Global substitution (replace all the same elements in the case study) is not available for this dataset\nbecause the link with its original dataset is broken.\n",
            "replace_in_ref_id": {
              "add_replacement_id": "Add a location",
              "choose_cs_phase_or_container": "All the same datasets in one or more locations to select",
              "cs_case_study": "All the same datasets in this case study",
              "none": "Only this dataset"
            },
            "replace_in_ref_id_label": "Substitute",
            "submit": "替换",
            "suggested_substitutions": "建议的替代品",
            "tooltip_formula": "您可以在这一栏中填写公式，包括四种常用运算（+、-、*、/）以及常用数学函数。"
          },
          "help": {
            "energetic_mix": "能量组合与其原始模块密不可分。如果新模块是可配置的，则必须为其重新分配能量组合。",
            "label_energetic_mix": "能量组合",
            "label_substitutions": "建议",
            "label_units": "单位",
            "net_calorific_value": "如果存在，较低的热值会自动被新数据的热值取代。",
            "quantity": "默认情况下，将保留您的数量公式。您也可以应用比率。例如，如果新数据的单位组不同于旧数据的单位组。您的原始公式将被保留，比率应用如下： '（原始公式）*（比率）'。",
            "renewable_percentage": "如果存在，可再生材料百分比值将自动被新数据值取代。",
            "second_quantity": "与主要数量一样，可以保留数值或应用比率。您也可以选择应用新数据的默认值。在这种情况下，它将覆盖您的旧值。",
            "substitutions": "在可能的情况下，我们建议用替换数据来代替过时数据。请注意注释中的注意事项。",
            "units": "如果新数据所需的单位组（质量单位、公制单位......）与旧数据不同，模块将被赋予新单位组的默认单位。"
          },
          "replace": {
            "title": "代课老师"
          }
        },
        "cs_transport_steps": {
          "form_component": {
            "no_ratio_for_transport_steps": "Please note that automatic application of ratios is not possible for transport steps.",
            "origin_dataset": "Origin dataset",
            "recommended": "We recommand to choose this dataset by default.",
            "replace_all_is_unavailable": "Global substitution (replace all the same elements in the case study) is not available for this transport\nbecause the link with its original dataset is broken.\n",
            "replace_in_ref_id": {
              "add_replacement_id": "Add a location",
              "choose_cs_phase_or_container": "All the same transports in one or more locations to select",
              "cs_case_study": "All the same transports in this case study",
              "none": "Only this transport"
            },
            "replace_in_ref_id_label": "Substitute",
            "replacement_dataset": "Replacement dataset",
            "submit": "Substitute",
            "suggested_substitutions": "Suggested substitutions"
          },
          "help": {
            "label_load_rates": "Average load and empty return percentages",
            "label_other_attributes": "Total transported mass, distance, and rate",
            "label_substitutions": "Suggestions",
            "load_rates": "You can fill in these fields if you are switching from air, sea, or rail transport to road transport.\nYou can also leave the default values.\n",
            "other_attributes": "During substitution, these parameters will remain unchanged.",
            "substitutions": "Whenever possible, we suggest replacement data for obsolete data.\nPlease note the points of caution in the comments.\n"
          },
          "replace": {
            "title": "Substitute"
          }
        }
      },
      "statuses": {
        "create": {
          "success": "成功"
        }
      },
      "templates_collection": {
        "create": {
          "notice": "The case study has been defined as global template."
        },
        "destroy": {
          "notice": "The case study has been removed from global templates."
        }
      },
      "update": {
        "notice": "通知"
      },
      "users_cs_item": {
        "update": "更新"
      },
      "users_cs_items": {
        "create": {
          "notice": "通知"
        },
        "permission_remove": "删除权限",
        "update_all": {
          "notice": "权限已更新。",
          "protection_error": "无法为项目所有者 %{name} 设置权限。"
        }
      }
    },
    "no_results": "无结果",
    "ok": "OK",
    "project": {
      "actions": {
        "archive": {
          "name": "存档/解除存档",
          "shortcut": "Maj + A"
        },
        "bookmark": {
          "name": "书签",
          "shortcut": "快捷方式"
        },
        "copy_item": {
          "name": "复制",
          "shortcut": "Maj + C"
        },
        "cut_item": {
          "name": "复制",
          "shortcut": "Maj + X"
        },
        "delete_item": {
          "name": "删除",
          "shortcut": "Del"
        },
        "duplicate": {
          "name": "重复",
          "shortcut": "Maj + D"
        },
        "edit_item": {
          "name": "编辑",
          "shortcut": "Maj + E"
        },
        "edit_line": {
          "name": "重新命名",
          "shortcut": "E"
        },
        "export": {
          "name": "出口",
          "shortcut": "快捷方式"
        },
        "export_analysis": {
          "name": "出口分析",
          "shortcut": "快捷方式"
        },
        "export_design": {
          "name": "出口设计",
          "shortcut": "快捷方式"
        },
        "export_eime": {
          "name": "导出为 EIME 格式",
          "shortcut": "快捷方式"
        },
        "export_inies": {
          "name": "导出为 INIES 格式",
          "shortcut": "快捷方式"
        },
        "export_pep_ecopassport": {
          "name": "导出为 PEP Ecopassport 格式",
          "shortcut": "快捷方式"
        },
        "go_to_analysis": {
          "name": "转到分析",
          "shortcut": "A"
        },
        "go_to_comparison": {
          "name": "转到比较",
          "shortcut": "快捷方式"
        },
        "go_to_design": {
          "name": "转到设计",
          "shortcut": "D"
        },
        "import": {
          "name": "导入案例研究",
          "shortcut": "快捷方式"
        },
        "paste_item": {
          "name": "粘贴",
          "shortcut": "Maj + P"
        },
        "remove_global_template": {
          "name": "从全局模板中删除"
        },
        "share": {
          "name": "分享",
          "shortcut": "快捷方式"
        },
        "status": {
          "name": "现状",
          "shortcut": "快捷方式"
        },
        "transform_to_template": {
          "name": "转换为模块",
          "shortcut": "Maj + T"
        },
        "unarchive": {
          "name": "解除存档/存档",
          "shortcut": "Maj + A"
        },
        "unmark_as_template": {
          "name": "取消标记为模板"
        }
      },
      "add": {
        "case_study": {
          "name": "新案例研究",
          "shortcut": "Maj + C"
        },
        "folder": {
          "name": "新文件夹",
          "shortcut": "Maj + D"
        },
        "project": {
          "name": "新项目",
          "shortcut": "Maj + P"
        }
      },
      "cs_case_studies": {
        "bookmark": {
          "add": "这个案例分析已加入收藏夹。您可以在\"系统\"菜单里找到它",
          "remove": "这个案例分析已从收藏夹移除。"
        },
        "create": {
          "notice": "正在建立新的案例分析。"
        },
        "destroy": {
          "notice": "案例分析删除成功。"
        },
        "indicators_set": {
          "error": "这套指标无法更改。",
          "notice": "这套指标已经更改。"
        },
        "share": {
          "add": "案例分析已被成功分享。您可以在\"系统\"菜单里找到它",
          "remove": "案例分享已取消。"
        },
        "update": {
          "notice": "案例分析编辑成功。"
        }
      },
      "cs_case_study_statuses": {
        "back": "费尔默",
        "create": {
          "success": "案例研究状态已被修改。"
        },
        "submit": "确认"
      },
      "cs_projects": {
        "reject_edit": "您不得修改此项目",
        "reject_insert": "不允许创建项目"
      },
      "delete_confirm": "您确定要删除这个/这些项目吗？",
      "delete_denied": "无法销毁非空项目。",
      "details": {
        "analysis": "分析",
        "creation": "创造",
        "creation_type": "创建类型",
        "database": "数据库",
        "db_module_released_at": "版本",
        "db_module_released_at_unset": "最新默认",
        "default_template": "%{name} (默认)",
        "functional_unit": "功能单元",
        "inies": "INIES 信息",
        "less_info": "更少信息",
        "more_info": "更多信息",
        "notes": "说明",
        "permissions": "权限",
        "title": "详细信息",
        "unset": "未设置"
      },
      "display": {
        "visible_columns": "可见结肠"
      },
      "filter_type": {
        "ecobilan_all": "所有项目中的生态平衡",
        "ecobilan_current": "当前项目或文件夹中的 ecobilan",
        "name_all": "所有项目中的名称",
        "name_current": "当前项目或文件夹中的名称"
      },
      "filter_user": {
        "all": "全部",
        "default": "默认值",
        "label": "按用户筛选 ："
      },
      "global": {
        "import": {
          "name": "进口商",
          "shortcut": "快捷方式"
        }
      },
      "index": {
        "title": "我的项目"
      },
      "items_filter_component": {
        "filter_by": "筛选方式",
        "search": "搜索",
        "update": "更新"
      },
      "library": {
        "clear": "清晰",
        "search": "搜索"
      },
      "overview": {
        "badges": {
          "instance_template": "实例模板"
        },
        "columns": {
          "badges": {
            "db_locked": "在固定日期锁定数据库",
            "read_only": {
              "description": "只读：您不是所有者",
              "text": "只读"
            },
            "templated": "<p><string>模板化</string></p>\n<p>本案例研究可用作新案例研究的模板。要在案例研究创建表中使用，必须先将其添加到项目中。</p>\n"
          },
          "bookmark_icon": "书签",
          "buttons": "行动",
          "comments": "评论",
          "created_at": "创建于",
          "db_module_released_at": "模块日期",
          "ico": "Ico",
          "id": "Id",
          "name": "名称",
          "path": "路径",
          "rank": "等级",
          "share_icon": "分享",
          "state": "国家",
          "status": "现状",
          "team": "团队",
          "updated_at": "更新于",
          "user": "业主"
        }
      },
      "search": {
        "clear": "清除",
        "placeholder": "搜索",
        "search_elements": "搜索要素",
        "submit": "研究员",
        "tooltip": "工具提示"
      },
      "virtual_root": "我的项目",
      "virtual_root_archived": "我的存档项目"
    },
    "ui": {
      "flying_notifications_component": {
        "dismiss": "Dismiss"
      },
      "interactive_breadcrumb": {
        "breadcrumb": {
          "clear": "清晰"
        }
      },
      "interactive_breadcrumb_category_component": {
        "clear": "清晰"
      },
      "toggle_panel_bar_component": {
        "maximize": "最大化侧板",
        "minimize": "减少侧板"
      }
    }
  }
}